import NotifyHelper from './notify';
import SmartGiftHelper from './smartGiftHelper';
import { startCarouselTileImageFunction } from './productBox';
import { updatePrimaryImagesSlider } from './detail';
import sizePanel from './sizePanel';
import { addToCartFromListing } from './quickView.js';
import { newModalFromString } from '../components/modal';
import { runPersonalizationListener, handleVariationGroupChange } from '../customize';
import { updateProductDetailUrl } from 'util/url';
import { createCookie } from '../util/common';
import { getGtmData } from '../analytics/helpers/helper';
import { handleWishlistContainer } from './wishlistHeart.js';
import { throttle } from 'lodash';
import {initializeTooltips} from '../productTileComponent/productTile';

const isMiniCartOpen = () => {
    return localStorage.getItem('isMiniCartOpen') === 'true';
};

function isChooseBonusProductModalOpen() {
    return ($('.js-chooseBonusProductModal').length > 0);
}

function isQuickUpdateFromModal() {
    return $('.js-quickUpdateModal').length > 0;
}

const isMobileDevice = () => {
    return !Foundation.MediaQuery.atLeast('large');
};
/**
 * Move close button inside modal content box
 */
const moveModalCloseButton = () => {
    var close = document.querySelector('.tingle-modal__close');
    var modalContent = document.querySelector('.tingle-modal-box__content');
    modalContent.appendChild(close);
};

function getInitalProductColor (currentTarget) {
    const hoverColorSelector = $(currentTarget).find('.js-change-name-on-hover');
    var initalProductColorShown = hoverColorSelector.data('attr-value-name');
    window.sessionStorage.setItem('initalProductColorShown', initalProductColorShown);
    var initalProductColorShownId = hoverColorSelector.data('attr-value');
    window.sessionStorage.setItem('initalProductColorShownId', initalProductColorShownId);
}

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
const getPidValue = ($el) => {
    let pid;

    if ($('.quickview-modal').hasClass('tingle-modal--visible') && !$('.product-set').length) {
        pid = $('.quickview-modal').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else if ($('.modal-size-show').length) {
        pid = $('.modal-size-show').find('.js-add-to-cart').data('pid');
    } else if (isMiniCartOpen()) {
        pid = $($el).data('pid');
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
};

/**
 * updates the product view when a product attribute of quickAdd is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {string} type - type of filter selected
 */
const attributeSelectQuickAdd = (selectedValueUrl, $productContainer, type = '_', imagesShouldUpdate = true) => {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect', {
            url: selectedValueUrl,
            container: $productContainer
        });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: data => {
                handleVariantResponseQuickAdd(data, $productContainer, imagesShouldUpdate);
                updateOptions(data.product.options, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                $productContainer.attr('data-pid', data.product.id);
                $productContainer.find('.add-to-cart-quick-add').attr('data-pid', data.product.id);
                $productContainer.find('.add-to-cart-quick-add').attr('data-quantity', data.product.selectedQuantity);
                if ($productContainer.find('.add-to-cart-quick-add').data('mustAdd') === true) {
                    $productContainer.find('.add-to-cart-quick-add').trigger('click');
                } else {
                    $productContainer.find('.js-panel-opener-size-quick-add').trigger('click');
                    $.spinner().stop();
                }
            },
            error: () => {
                $.spinner().stop();
            }
        });
    }
};

const activatePromoAnimationMessage = () => {
    $('.js-pdpPromo').removeClass('hide');
};

const reactivatePromoAnimationMessage = (promotionId, pdpCalloutMsgText) => {
    $('.js-pdpPromo').attr('data-promotion-id', promotionId);
    $('.js-pdpPromo-message').html(pdpCalloutMsgText);
    activatePromoAnimationMessage();
};

/**
 * updates the product view when a product attribute is selected or deselected or when changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {string} type - type of filter selected
 * @param {boolean} imagesShouldUpdate - update images on attribute selection
 * @param {boolean} ignoreCTA - add immediately to cart without clicking on CTA
 */
const attributeSelect = (selectedValueUrl, $productContainer, type = '_', imagesShouldUpdate = true, ignoreCTA = false) => {
    if (selectedValueUrl) {
        // destroyPrimaryImagesSlider();
        $productContainer.prevObject.analyticsPromotion = false;

        $('body').trigger('product:beforeAttributeSelect', {
            url: selectedValueUrl,
            container: $productContainer
        });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: data => {
                var isSize = data.variation.isSize;
                var isQuickViewModal = $productContainer.hasClass('product-quickview');

                if (isQuickViewModal && type !== 'color') {
                    imagesShouldUpdate = false;
                }

                if (data.htmlVar && $productContainer) {
                    $productContainer.find('.js-sizeBox-openPanel,.js-pdpStickyBar-size-openPanel,.js-switch-buttons,.js-pdpStickyBar-select .js-add-to-cart').html(data.htmlVar);
                }

                if (data.htmlProd && $productContainer) {
                    $productContainer.find('.js-add-to-cart').html(data.htmlProd);
                }

                handleVariantResponse(data, $productContainer, imagesShouldUpdate, type);
                if (data.promoMessageHtml) {
                    $productContainer.find('.cc-promo-container').replaceWith(data.promoMessageHtml);
                } else {
                    handleCustomPromoTags(data.promoTagList,$productContainer,'second');
                    const firstLevelList = data.product && data.product.processedCustomTags && data.product.processedCustomTags.firstLevelList || [];
                    handleCustomPromoTags(firstLevelList,$productContainer,'first');
                }

                // Update PDP link if we are in QuickView and a color was selected
                if (type === 'color' && $('.quickview-modal').length) {
                    let container = $('.quickview-modal').find('.see-product-details-link');
                    container.attr('href', data.product.url);
                }

                handleVariationUrlsSelectSizeModal(data.variation.variationUrls);
                handlePromotionTag(data.product, $productContainer);
                handleVariationUrlsSelectNotifyModal(data.product.variationAttributes[1].values);
                handleVariationComingSoonNotifyModal(data.product.variationAttributes[1].values);
                handleVariationComingSoon(data.product.comingSoon);
                handleVariationWishlistModal(data.product.variationAttributes[1].values);

                var $shopTheLookBtn = $productContainer.find('.js-shopTheLook-button');
                if (data.product.comingSoon || data.product.isSoldout || !data.product.pdpCrossSell) {
                    $shopTheLookBtn.addClass('hide');
                } else {
                    $shopTheLookBtn.removeClass('hide');
                }
                
                // here we check if the selected product has the size, if not we put a flag on isToLoad
                if (isSize == false) {
                    $('#pidToAdd').attr('isToLoad', 'true');
                } else {
                    $('#pidToAdd').attr('isToLoad', 'false');
                }
                $('.persButtonPdpPers').attr('disabled', false);
                $('#custom-page').attr('data-pid', data.product.id);
                $('.js-personalizeButtonCheckout').removeClass('disabled');
                $('.js-personalizeButtonCheckout').attr('disabled', false);
                updateOptions(data.product.options, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                updateImageSaveForLater(data.product, $productContainer);
                if ($('.product-detail-keeper').length) {
                    var pid = getPID(data.product);
                    try {
                        $($productContainer).find('.product-set').attr('data-pid', pid);
                    } catch (e) {
                    }
                    $('.product-detail-keeper').attr('data-variant-pid', encodeURIComponent(pid));
                }

                $('body').trigger('product:afterAttributeSelect', {
                    data: data,
                    container: $productContainer,
                    type: type
                });

                if (type === 'color') {
                    showPromoMessage(data);
                    updateSelectedSize();
                }

                const _updateInformation = (product) => {
                    let selectorPrefix = '';
                    if (product.variationAttributes[0].onSaleSelected || product.price.saleType) {
                        selectorPrefix = '.onSaleContainer';
                    } else {
                        selectorPrefix = '.notOnSaleContainer';
                    }

                    $productContainer.find(selectorPrefix + ' .js-discount-msg').addClass('hidden');
                    $productContainer.find(selectorPrefix + ' .js-promo-msg').addClass('hidden');

                    if (product.price.discountValue) {
                        $productContainer.prevObject.analyticsPromotion = true;
                        $productContainer.find(selectorPrefix + ' .js-discount-msg')
                            .html(`(${product.price.discountValue}%)`)
                            .removeClass('hidden');
                        if (product.promotions && product.promotions.length > 0) {
                            if (product.promotions[0].calloutMsg) {
                                $productContainer.find(selectorPrefix + ' .js-promo-msg')
                                    .html(product.promotions[0].calloutMsg)
                                    .removeClass('hidden');
                            } else if (product.promotions[1] && product.promotions[1].calloutMsg) {
                                $productContainer.find(selectorPrefix + ' .js-promo-msg')
                                    .html(product.promotions[1].calloutMsg)
                                    .removeClass('hidden');
                            }
                        }
                    } else if (product.promotions && product.promotions.length > 0) {
                        $productContainer.prevObject.analyticsPromotion = true;
                        if (product.promotions[0].calloutMsg) {
                            $productContainer.find(selectorPrefix + ' .js-promo-msg')
                                .html(product.promotions[0].calloutMsg)
                                .removeClass('hidden');
                        } else if (product.promotions[1] && product.promotions[1].calloutMsg) {
                            $productContainer.find(selectorPrefix + ' .js-promo-msg')
                                .html(product.promotions[1].calloutMsg)
                                .removeClass('hidden');
                        }
                    }
                };

                if (type !== 'size') {
                    _updateInformation(data.product);
                }

                if ($('.modal-size-show').length) {
                    $.spinner().stop();
                    if (type === 'size') {
                        $('body').trigger('quickBuy:addToCart', data);
                    }
                }

                if ($('.js-customizePage').length > 0 && data.totalQuantityPrice) {
                    $('.js-personalizePrice').text(data.totalQuantityPrice);
                }

                if (type === 'color') {
                    updatePreviouslyPurchasedSizeLabel(data.product);
                }

                handleInexistentSizeQuickView(data);
                handleWishlistContainer(data.product.id);
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    let current_url = window.location.pathname.split('/');
                    var localized_error_page = window.location.protocol + '://' + window.location.host;
                    for (var i = 0; i < current_url.length; i++) {
                        if (current_url[i] !== 'product') {
                            localized_error_page += '/' + current_url[i];
                        } else {
                            localized_error_page += '/404/';
                            break;
                        }
                    }
                    console.log('localized_error_page = ' + localized_error_page);
                    window.location.href = localized_error_page;
                }
                $.spinner().stop();
            }
        }).then(function (data) {
            let stopSpinner = sizePanel.afterSizeSelection(data, type);
            if (stopSpinner) {
                $.spinner().stop();
            }
            if (ignoreCTA) {
                $('.js-prod-select-size-modal').find('button.js-add-to-cart').trigger('click');
            }
            if (type === 'color') {
                if (data.product.promotions.length === 0) {
                    $('.js-pdpPromo').addClass('hide');
                } else if (data.product.promotions[0].id && data.product.promotions[0].id != $('.js-pdpPromo').attr('data-promotion-id')) {
                    reactivatePromoAnimationMessage(data.product.promotions[0].id, data.product.promotions[0].pdpCalloutMsgText);
                } else {
                    $('.js-pdpPromo').removeClass('hide');
                }
            }
        });
    }
};

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
const getQuantitySelector = ($el) => {
    return $el && $('.set-items').length ?
        $($el).closest('.product-detail').find('.quantity-select') :
        $('.quantity-select');
};

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
const getQuantitySelected = ($el) => {
    let quantity = 1;
    if ($el.hasClass('js-add-to-cart-multipack') && $el.data('bundle-quantity')) {
        quantity = $el.data('bundle-quantity');
    } else if ($el.closest('.js-complete-your-promo-quick-view').length > 0) {
        quantity = $el.closest('.wrapper-inner-quick-bottom').find('.js-quick-quantity').val();
    } else if (getQuantitySelector($el).val()) {
        quantity = getQuantitySelector($el).val();
    }
    return quantity;
};

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
const processSwatchValues = (attr, $productContainer) => {
    attr.values.forEach(attrValue => {
        const $attrValue = $productContainer.find(`[data-attr="${attr.id}"] [data-attr-value="${attrValue.value}"]`);
        const $swatchAnchor = $attrValue.parent();

        if (attrValue.selected) {
            $productContainer.find('.attribute-label').text(attrValue.id.toLowerCase() + ' - ' + attrValue.displayValue.toLowerCase());
            if ($('.js-pdpStickyBar-colorWrapper').length > 0) {
                $('.js-pdpStickyBar-colorWrapper .label-inside').text(attr.displayName + ': ' + attrValue.displayValue.toLowerCase() + ' - ' + attrValue.id.toLowerCase());
                $('.js-pdpStickyBar-colorWrapper img').attr('src', attrValue.images.swatch[0].url);
                $('.js-pdpStickyBar-colorWrapper img').attr('alt', attrValue.displayValue.toLowerCase() + ' - ' + attrValue.id.toLowerCase());
            }
            if ($attrValue[0]) {
                $productContainer.find(`[data-opener="${attr.id}"] .attribute-selection`).html($attrValue[0].outerHTML);
                $attrValue.addClass('selected');
            }
        } else {
            $attrValue.removeClass('selected');
        }

        if (attrValue.url) {
            $swatchAnchor.attr('data-url', attrValue.url);
        } else {
            $swatchAnchor.removeAttr('data-url');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable soldout');
        $attrValue.addClass((attrValue.selectable || attrValue.isSoldout) ? 'selectable' : 'unselectable');
        if (attrValue.isSoldout) {
            $attrValue.addClass('soldout');
        }
    });
};

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
const processNonSwatchValues = (attr, $productContainer, variantType) => {
    const $attr = `[data-attr="${attr.id}"]`;
    const $defaultOption = $productContainer.find(`${$attr} .select-${attr.id} option:first`);
    $defaultOption.attr('value', attr.resetUrl);
    $productContainer.find(`[data-opener="${attr.id}"] .attribute-selection`).html('');

    $productContainer.find('.js-intProductDetail-size-item').addClass('hide');
    attr.values.forEach(attrValue => {
        if ($('.page').data('action') && $('.page').data('action').toLowerCase().indexOf('product-show') > -1 && $('#personalize-page') && !$productContainer.hasClass('js-complete-your-promo-quick-view')) {
            $productContainer = $('.js-intProductDetail');
        }
        const $attrValue = $productContainer.find(`${$attr} [data-attr-value="${attrValue.value}"]`);
        const $attrValueMobile = $productContainer.find(`.size-panel-mobile-content [data-attr-value="${attrValue.value}_mobile"]`);
        $attrValue.attr('value', attrValue.variationUrl || attrValue.url).removeAttr('disabled');
        $attrValueMobile.attr('value', attrValue.variationUrl);
        if (!attrValue.selected) {
            $attrValueMobile.removeAttr('disabled');
        }
        $attrValue.attr('disabled', !attrValue.selectable);
        if (attrValue.isComingSoon && $productContainer.hasClass('product-quickview')) {
            $attrValue.attr('disabled', attrValue.isComingSoon);
        }

        if (attrValue.selected && attrValue.selectable && attrValue.id !== 'TU') {
            $productContainer.find(`[data-opener="${attr.id}"] .attribute-selection`).html(attrValue.displayValue);
            $productContainer.find('.product-quickview').data('pid', attrValue.sku);
        }

        if (attrValue.selected && attrValue.selectable) {
            const selectedSizeSpan = $productContainer.find('.js-selected-size');

            if (selectedSizeSpan.length) {
                selectedSizeSpan.text(attrValue.displayValue);
            }
        }

        if ($attrValue.length > 1) {
            $attrValue.each((i, el) => {
                $(el).prop('checked', attrValue.selected && attrValue.selectable);
            });
        } else {
            $attrValue.prop('checked', attrValue.selected && attrValue.selectable);
        }

        if (variantType !== 'size') {
            if (!attrValue.selectable || attrValue.isComingSoon) {
                if ($('#isNotifyActive').val() == 'true') {
                    $attrValue.siblings().addClass('notifyMe');
                    $attrValueMobile.siblings().addClass('notifyMe');
                } else {
                    $attrValue.siblings().addClass('wishlistOnly');
                    $attrValueMobile.siblings().addClass('wishlistOnly');
                }
            } else {
                $attrValue.siblings().removeClass('notifyMe wishlistOnly');
                $attrValueMobile.siblings().removeClass('notifyMe wishlistOnly');
            }
            if (attrValue.lowAvailability) {
                $attrValue.siblings().addClass('low-stock');
                $attrValueMobile.siblings().addClass('low-stock');
            } else {
                $attrValue.siblings().removeClass('low-stock');
                $attrValueMobile.siblings().removeClass('low-stock');
            }
        }

        // Toggle size if disabled or not
        $attrValue.closest('label').toggleClass('hide', attrValue.disabled);
        $attrValueMobile.closest('label').toggleClass('hide', attrValue.disabled);

        // Toggle size in stickybar
        $('.js-pdpStickyBar').find('#' + $attrValue[0].id.replace('/', '\\/')).closest('label').toggleClass('hide', attrValue.disabled);

        // Same check on quick view mobile
        $attrValue.closest('.label-wrapper').toggleClass('hide', attrValue.disabled);

        // Toggle selectable size on cart quickview
        if ($('.quickview-modal').length) {
            $attrValue.closest('.boolean-field').toggleClass('cc-cartQuickView_selectedSize', attrValue.selected);
        }
    });

    // Update also size selection modal
    const $sizeSelectorContainer = $('#fis-select-size');
    attr.values.forEach(attrValue => {
        const $attrValue = $sizeSelectorContainer.find(`[data-attr-value="${attrValue.value}"]`);
        $attrValue.attr('disabled', !attrValue.selectable);
        if (attrValue.isComingSoon && $productContainer.hasClass('product-quickview')) {
            $attrValue.attr('disabled', attrValue.isComingSoon);
        }

        if ($('#isNotifyActive').val() == 'true') {
            if (!attrValue.selectable || attrValue.isComingSoon) {
                $attrValue.addClass('notifyMe notifyPopup');
                $attrValue.find('.notifyIcon').removeClass('hide');
            } else {
                $attrValue.removeClass('notifyMe notifyPopup');
                $attrValue.find('.notifyIcon').addClass('hide');
            }
        } else {
            if (!attrValue.selectable) {
                $attrValue.addClass('wishlistOnly');
            } else {
                $attrValue.removeClass('wishlistOnly');
            }
        }

        // Toggle size if disabled or not
        $attrValue.parent('li').toggleClass('hide', attrValue.disabled);

        // TODO: improve check. Force size selection of quick add on PDP mobile
        if (!Foundation.MediaQuery.atLeast('large') && $productContainer.closest('.product-quickview').length) {
            $productContainer.find(`.mobile-attributes-container input[id="${attrValue.value}"]`).prop('checked', attrValue.selected && attrValue.selectable);
        }
    });
};

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {string} variantType - Size or Color selection
 * @param {jQuery} $productContainer - DOM element for a given product
 */
const updateAttrs = (attrs, $productContainer, variantType) => {
    // Currently, the only attribute type that has image swatches is Color.
    const attrsWithSwatches = ['color'];

    if ($('.js-personalizeButtonModal').attr('data-personalized') === 'true') {
        $productContainer = $('.fis-select-size');
    }

    attrs.forEach(attr => {
        if (attrsWithSwatches.indexOf(attr.attributeId) > -1) {
            processSwatchValues(attr, $productContainer);
        } else {
            processNonSwatchValues(attr, $productContainer, variantType);
        }
    });
};

const updateScanTrustLink = (attr, $productContainer) => {
    let $productAuthenticity = $productContainer.find('.cc-details-authenticity-paragraph');
    if ($productAuthenticity.length > 0) {
        $productAuthenticity.find('.js-update-scantrustUrl').attr('href', attr.scanTrustUrlWithParams);
    }
}

const updateloyaltyBannerPoints = (response, $productContainer) => {
    let $productLoyaltyBanner = $productContainer.find('.js-update-loyalty-points-to-receive');
    if ($productLoyaltyBanner.length > 0) {
        $productLoyaltyBanner.text(response.product.loyaltyPdpPoints);
    }
}

const updateSelectedSize = () => {
    $('.js-mobile-size-selected').removeClass('js-mobile-size-selected');
    $('.cc-intProductDetail-size-item_selected').removeClass('cc-intProductDetail-size-item_selected');
    $('.js-intProductDetail-size-item input[type="radio"]').prop('checked', false);
    $('[data-attr="size"] input[type="radio"], [data-attr="size-mobile"] input[type="radio"]').prop('checked', false);
    
    $('.js-selected-size:not(.js-selected-size-not-available)').text('');
    $('[data-opener="size"] .attribute-selection').text('');
    $('.pdp-size-box').removeClass('size-selected');
 
    $('.js-sizeBox-openPanel').removeClass('hidden');
    $('.js-addToCartWrapper').addClass('hidden');
 
    $('.js-pdpStickyBar-select .js-add-to-cart').removeClass('hide-when-size-selected').addClass('show-when-size-selected');
    $('.js-pdpStickyBar-select .js-pdpStickyBar-size-openPanel').removeClass('show-when-size-selected').addClass('hide-when-size-selected');
 
    const $wrapper = $('.js-pdpStickyBar');
    $wrapper.find('.cc-quantity-sticky-show').removeClass('cc-quantity-sticky-show').addClass('cc-quantity-sticky');
    $wrapper.find('.js-quantity-button-sticky').off('click').removeClass('js-quantity-button-sticky').addClass('js-quantity-button');
    $wrapper.find('.js-quantity-value-sticky').removeClass('js-quantity-value-sticky').addClass('js-quantity-value');
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
const updateAvailability = (response, $productContainer) => {
    let availabilityValue = '';
    let availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = `<div>${response.resources.info_selectforstock}</div>`;
    } else if (response.product.availability.orderable) {
        availabilityMessages.forEach(message => {
            availabilityValue += `<div>${message}</div>`;
        });
    }

    if ($('.js-personalizeButtonModal').length > 0) {
        $productContainer = $('.tingle-modal-box__content');
    }

    $productContainer.find('.js-soldOut-message').addClass('hidden');
    if (!response.product.available || response.product.comingSoon || response.product.isSizeInexistent) {
        $productContainer.find('.js-soldOut-message').removeClass('hidden');
        $productContainer.find('.js-selected-size:not(.js-selected-size-not-available)').text('-');
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });

    if ($productContainer.hasClass('js-intProductDetail')) {
        if (response.product.isSoldout === true) {
            $productContainer.addClass('cc-isSoldOut js-isSoldOut');
        } else {
            $productContainer.removeClass('cc-isSoldOut js-isSoldOut');
        }
    }
};

/**
 * Generates html for quick add form
 *
 * @param {string} pid - pid used to get variation
 * @param {string} url - url of the Controller
 * @return Compiled HTML
 */
const showQuickAddItems = (pid, url) => {
    if ($('.js-modal-quick-add-size-quantity').attr('data-pid') === pid) {
        $('.js-modal-quick-add-size-quantity').removeClass('hidden');
        return;
    }
    $('.select-size-quick-add-container').empty();
    $.spinner().start();
    $.ajax({
        url: url,
        method: 'GET',
        data: {
            pid: pid
        },
        success: function (data) {
            $('.select-size-quick-add-container[data-pid="' + pid + '"]').html(data);
            const $productContainer = $('.select-size-quick-add-container[data-pid="' + pid + '"]').closest('.product-detail-quick-add');
            $productContainer.find('.add-to-cart-quick-add').attr('data-quantity', 1);
            var selectedValue = $productContainer.find('.add-to-cart-quick-add').attr('data-size-selected');
            if (selectedValue) {
                $productContainer.find('[data-attr-id="' + selectedValue + '"]').attr('checked', true);
                $productContainer.find('.add-to-cart-quick-add').attr('data-size-available', true);
            } else {
                $productContainer.find('.add-to-cart-quick-add').attr('data-size-available', false);
                $productContainer.find('.size-selected').empty();
            }
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
};

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} options - Ajax response options from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
const updateOptions = (options, $productContainer) => {
    options.forEach(option => {
        const $optionEl = $productContainer.find(`.product-option[data-option-id*="${option.id}"]`);
        option.values.forEach(value => {
            const valueEl = $optionEl.find(`option[data-value-id*="${value.id}"]`);
            valueEl.val(value.url);
        });

        option.values.forEach(value => {
            const valueEl = $optionEl.find(`input[id="${value.id}"]`);
            valueEl.data('href', value.url);
            valueEl.attr('href', value.url);
        });
    });
};

const updateColorFamily = (product, $productContainer) => {
    $productContainer.find('.family-color').text(product.colorFamily.toLowerCase() + ' - ');
    window.sessionStorage.setItem('initalProductColorShownColorFamily', product.colorFamily.toLowerCase());

    for (let attr of product.variationAttributes) {
        if (attr.attributeId === 'color') {
            if (attr.onSaleSelected) {
                $productContainer.find('.product-color-sales.on-sale').removeClass('hidden');
                $productContainer.find('.product-color-sales.not-on-sale').addClass('hidden');
            } else {
                $productContainer.find('.product-color-sales.on-sale').addClass('hidden');
                $productContainer.find('.product-color-sales.not-on-sale').removeClass('hidden');
            }
        }
    }
};

const updatePrices = (product, $productContainer, resources) => {
    if (!product.variationAttributes ||
        !product.variationAttributes[0] ||
        product.variationAttributes[0].attributeId !== 'color') {
        return;
    }
    let selectorPrefix = '';
    if (product.variationAttributes[0].onSaleSelected || product.price.discountValue) {
        selectorPrefix = '.onSaleContainer';
    } else {
        selectorPrefix = '.notOnSaleContainer';
    }
    const priceSelector = selectorPrefix + '.prices .price';
    const priceInfoSelector = ':not(.js-omnibusLabel-wrapper) > .cc-priceOmnibusLabel .price-info';
    const $oldPriceInfoSelector = $(':not(.js-omnibusLabel-wrapper) > .cc-priceOmnibusLabel .js-oldPriceInfo');
    const $regularPriceInfoDiscountSelector = $('.js-priceInfo-discountValue');
    const $oldPriceInfoDiscountSelector = $('.js-oldPriceInfo-discountValue');
    const $pricePercentage = $('.js-pricePercentage');
    const $priceSelector = $(priceSelector, $productContainer).length ?
        $(priceSelector, $productContainer) :
        $(priceSelector);
    const $priceInfoSelector = $(priceInfoSelector, $productContainer).length ?
        $(priceInfoSelector, $productContainer) :
        $(priceInfoSelector);
    const priceInfoInSaleContainerSelector = '.cc-intProductDetail-colors .cc-priceOmnibusLabel .price-info';
    const $priceInfoInSaleContainerSelector = $(priceInfoInSaleContainerSelector, $productContainer);
    const priceInfoInSaleContainerSelector2 = '.cc-intProductDetail-colors .cc-priceOmnibusLabel .js-oldPriceInfo';
    const $priceInfoInSaleContainerSelector2 = $(priceInfoInSaleContainerSelector2, $productContainer);
    const $omnibusPricelForSpecificCountries = $('.js-intProductDetail-attributes-wrapper .js-priceOmnibusLabel .price-info');
    window.onSalesInfoPrice = $priceInfoInSaleContainerSelector.text();
    $priceSelector.replaceWith(product.price.html);
    const currentCountryOmnibus = $oldPriceInfoSelector.closest('.js-omnibusStack').data('currentcountry');
    const isRegularOmnibusCountry = $oldPriceInfoSelector.closest('.js-omnibusStack').data('omnibuscountry');
    if (product.price.sales.formattedPriceInfo) {
        $priceInfoSelector.parent().show();
        $priceInfoSelector.html(product.price.sales.formattedPriceInfo);
        const isCountryWithTooltip = currentCountryOmnibus === 'ES' || currentCountryOmnibus === 'SI';
        if (isCountryWithTooltip && resources.tooltip_omnibus && $('i.omnibus-tooltip').length === 0) {
            $('.product-main-price.onSaleContainer .price').append('<i class="info-icon omnibus-tooltip" role="button" tabindex="0"><span class="icon-info-gray">i</span><div class="tooltip"><p class="price-info-tooltip">' + resources.tooltip_omnibus + '</p><div class="pos-relative"><div class="tooltip-tip"></div></div></div></i>');
        }
        if (isRegularOmnibusCountry) {
            $oldPriceInfoSelector.parent().show();
            $oldPriceInfoDiscountSelector.html(product.price.discountValueOmnibus + '%');
            $oldPriceInfoDiscountSelector.show();
        }
        $oldPriceInfoSelector.html(product.price.list.formatted);
        $regularPriceInfoDiscountSelector.html(product.price.discountValue + '%');
        $priceInfoInSaleContainerSelector.parent().addClass('hidden');
        $priceInfoInSaleContainerSelector2.parent().addClass('hidden');
        $omnibusPricelForSpecificCountries.parent().addClass('hidden');
        window.onSalesInfoPrice = product.price.sales.formattedPriceInfo;
        $priceInfoInSaleContainerSelector2.html(product.price.sales.oldPriceOmnibus.price);
        $pricePercentage.hide();
    } else {
        $priceInfoSelector.parent().hide();
        $priceInfoSelector.html('');
        if (window.onSalesInfoPrice) {
            if (currentCountryOmnibus === 'IT' || currentCountryOmnibus === 'ES' || currentCountryOmnibus === 'SI') {
                $omnibusPricelForSpecificCountries.parent().removeClass('hidden');
                $omnibusPricelForSpecificCountries.html(window.onSalesInfoPrice);
            } else if (isRegularOmnibusCountry) {
                $priceInfoInSaleContainerSelector.parent().removeClass('hidden');
                $priceInfoInSaleContainerSelector.html(window.onSalesInfoPrice);
                $priceInfoInSaleContainerSelector2.parent().removeClass('hidden');
            } else {
                $priceInfoInSaleContainerSelector.parent().removeClass('hidden');
                $priceInfoInSaleContainerSelector.html(window.onSalesInfoPrice);
            }
        }
        $oldPriceInfoSelector.parent().hide();
        $oldPriceInfoSelector.html('');
        if (product.price.discountValue) {
            $pricePercentage.show();
        }
    }

    if (product.doubleCurrency && product.doubleCurrency.html) {
        const $doubleCurrencyContainer = $('#descriptionSidebar  .js-priceSecondCurrency', $productContainer);
        const innerContent = $(product.doubleCurrency.html).html();
        $doubleCurrencyContainer.html(innerContent);
    }

    $productContainer.find(selectorPrefix + ' .js-discount-msg').addClass('hidden');
    $productContainer.find(selectorPrefix + ' .js-promo-msg').addClass('hidden');
    if (product.price.discountValue) {
        $productContainer.find(selectorPrefix + ' .js-discount-msg')
            .html(`(${product.price.discountValue}%)`)
            .removeClass('hidden');
        if (product.promotions && product.promotions.length > 0) {
            if (product.promotions[0].calloutMsg) {
                $productContainer.find(selectorPrefix + ' .js-promo-msg')
                    .html(product.promotions[0].calloutMsg)
                    .removeClass('hidden');
            } else if (product.promotions[1] && product.promotions[1].calloutMsg) {
                $productContainer.find(selectorPrefix + ' .js-promo-msg')
                    .html(product.promotions[1].calloutMsg)
                    .removeClass('hidden');
            }
        }
    } else if (product.promotions && product.promotions.length > 0) {
        if (product.promotions[0].calloutMsg) {
            $productContainer.find(selectorPrefix + ' .js-promo-msg')
                .html(product.promotions[0].calloutMsg)
                .removeClass('hidden');
        } else if (product.promotions[1] && product.promotions[1].calloutMsg) {
            $productContainer.find(selectorPrefix + ' .js-promo-msg')
                .html(product.promotions[1].calloutMsg)
                .removeClass('hidden');
        }
    }

    $productContainer.find(selectorPrefix + ' .js-loyalty').addClass('hidden');
    $productContainer.find(selectorPrefix + ' .js-loyaltysale').addClass('hidden');
    if (product.price.saleType) {
        let saleType = product.price.saleType;
        if (saleType === 'loyalty1' || saleType === 'loyalty2' || saleType === 'loyalty3' || saleType === 'loyalty4') {
            saleType = 'loyalty';
        } else if (saleType === 'loyaltysale1' || saleType === 'loyaltysale2' || saleType === 'loyaltysale3' || saleType === 'loyaltysale4') {
            saleType = 'loyaltysale';
        }
        $productContainer.find(selectorPrefix + ' .js-' + saleType).removeClass('hidden');
    }

    if (product.comingSoon) {
        $productContainer.find('.comingSoonBox').removeClass('hide');
        $productContainer.find('.comingSoonLabel-pdp').removeClass('hidden');
        $productContainer.find(selectorPrefix + ' .js-new-msg').addClass('hidden');
        $productContainer.find(selectorPrefix + ' .js-green-msg').addClass('hidden');
        // $productContainer.find(selectorPrefix + '.js-promo-msg').addClass('hidden');
    } else {
        $productContainer.find('.comingSoonBox').addClass('hide');
        $productContainer.find('.comingSoonLabel-pdp').addClass('hidden');
        $productContainer.find(selectorPrefix + ' .js-new-msg').addClass('hidden');
        $productContainer.find(selectorPrefix + ' .js-green-msg').addClass('hidden');
        if (product.New) {
            $productContainer.find(selectorPrefix + ' .js-new-msg').removeClass('hidden');
        }
        if (product.isGreen) {
            $productContainer.find(selectorPrefix + ' .js-new-msg').addClass('hidden');
            $productContainer.find(selectorPrefix + ' .js-green-msg').removeClass('hidden');
        }
        // $productContainer.find(selectorPrefix + '.js-promo-msg').removeClass('hidden');
    }
};

function updateAvailableQuantity(response) {
    let availableQuantity = response.product.availability && response.product.availability.allocation ?
        (response.product.availability.allocation >= 10 ? 10 : response.product.availability.allocation) :
        10;
    const $button = $('.js-quantity-button');
    updateQuantityPicker($button, availableQuantity);
}

const updatePreviouslyPurchasedSizeLabel = (product) => {
    $('.js-orderAgain-productDetails__label').data('pid', product.id).attr('data-pid', product.id);
    $('body').trigger('orderAgain:previouslyPurchasedSizeUpdate');
};

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
const handleVariantResponseQuickAdd = (response, $productContainer, imagesShouldUpdate = true) => {
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer);
    }

    updateAvailability(response, $productContainer);

    $('body').trigger('product:updateAddToCartQuickAdd', {
        product: response.product,
        $productContainer: $productContainer
    }).trigger('product:statusUpdate', response.product);
};

const updateImageSaveForLater = (product, $productContainer) => {
    $productContainer.find('.js-product-image-saveForLater').attr('src', product.images.small[0].url);
    $productContainer.find('.js-product-image-saveForLater').attr('alt', product.images.small[0].url);
    $productContainer.find('.js-product-image-saveForLater').attr('title', product.images.small[0].title);
};

const bindJpMobileImageCarouselEvents = ($productContainer) => {
    const $jpCarouselFooter = $productContainer.find('.js-intProductDetail-images-container-mobile .cc-intProductDetail-images-footer-mobile');

    if (!$jpCarouselFooter.length) {
        return;
    }

    const $primaryImages = $productContainer.find('.primary-images');

    $jpCarouselFooter
        .off('click.jpMobileImageCarousel', '.js-intProductDetail-images-mobile')
        .on('click.jpMobileImageCarousel', '.js-intProductDetail-images-mobile', function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            const imageIndex = parseInt($(this).attr('data-index'), 10);

            if (isNaN(imageIndex) || !$primaryImages.length || !$primaryImages.hasClass('slick-initialized')) {
                return;
            }

            $primaryImages.slick('slickGoTo', imageIndex);
        });

    if ($primaryImages.length) {
        $primaryImages
            .off('afterChange.jpMobileImageCarousel')
            .on('afterChange.jpMobileImageCarousel', function () {
                const $slickActive = $(this).find('.slick-active');
                const activeImg = $slickActive.attr('data-index');

                if (activeImg === undefined) {
                    return;
                }

                const $currentActiveImg = $jpCarouselFooter.find('.js-intProductDetail-images-mobile[data-index="' + activeImg + '"]');

                if (!$currentActiveImg.length) {
                    return;
                }

                $jpCarouselFooter.find('.js-intProductDetail-images-mobile .js-productImageCarouselItem-mobile').removeClass('active');
                $currentActiveImg.find('.js-productImageCarouselItem-mobile').addClass('active');

                $currentActiveImg[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'center'
                });
            });
    }
};

const updateJpMobileImageCarousel = (primaryImages, $productContainer) => {
    const $jpCarouselFooter = $productContainer.find('.js-intProductDetail-images-container-mobile .cc-intProductDetail-images-footer-mobile');

    if (!$jpCarouselFooter.length || !primaryImages || !primaryImages.length) {
        return;
    }

    const $carouselItems = $();

    primaryImages.forEach((imageData, imageIndex) => {
        const isEagerLoad = imageIndex < 2;
        let srcsetValue = '';

        if (imageData.resizedUrls && imageData.sizes && imageData.resizedUrls.length) {
            const srcSetArray = imageData.resizedUrls
                .map((resizedUrl, resizedUrlIndex) => {
                    const imageSize = imageData.sizes[resizedUrlIndex];

                    if (!imageSize || !imageSize.scaleWidth) {
                        return null;
                    }

                    return resizedUrl + ' ' + imageSize.scaleWidth + 'w';
                })
                .filter(Boolean);

            srcsetValue = srcSetArray.join(', ');
        }

        const imgClasses = ['cc-productImageCarouselItem-mobile', 'js-productImageCarouselItem-mobile', 'productImageCarouselItem'];

        if (!isEagerLoad) {
            imgClasses.push('lazyload');
        }

        const $img = $('<img>')
            .attr('class', imgClasses.join(' '))
            .attr('alt', imageData.alt || '')
            .attr('itemprop', 'image')
            .attr('sizes', '(max-width:640px) 100vw, 45vw')
            .attr('data-index', imageIndex);

        if (isEagerLoad && srcsetValue) {
            $img.attr('srcset', srcsetValue);
        }

        if (!isEagerLoad) {
            if (imageData.url) {
                $img.attr('data-src', imageData.url);
            }

            if (srcsetValue) {
                $img.attr('data-srcset', srcsetValue);
            }
        }

        const $wrapper = $('<div>')
            .attr('class', 'cc-intProductDetail-images cc-intProductDetail-images-mobile js-intProductDetail-images-mobile js-linkModalProductImageCarousel')
            .attr('data-index', imageIndex)
            .append($img);

        $carouselItems.push($wrapper[0]);
    });

    $jpCarouselFooter.empty().append($carouselItems);

    bindJpMobileImageCarouselEvents($productContainer);
};

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
const handleVariantResponse = (response, $productContainer, imagesShouldUpdate = true, variantType) => {
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, variantType);
        updateColorFamily(response.product, $productContainer);
        updateScanTrustLink(response, $productContainer);
        updateloyaltyBannerPoints(response, $productContainer);
    }
    const $container = $('.js-composition-info');

    if (response.product.partTypes) {
        $container.empty();
        const html = `<div class="comp-material">`;
        $container.append(html);

        for (var k = 0; k < response.product.partTypes.length; k++) {
            if (k == 0) {
                var type = `${response.product.partTypes[k].type}: `;
                $container.append(type);
            }
            if (k < response.product.partTypes.length - 1) {
                if (response.product.partTypes[k].type == response.product.partTypes[k + 1].type) {
                    var comp = `${response.product.partTypes[k].percentage} % ${response.product.partTypes[k].material}, `;
                    $container.append(comp);
                } else {
                    var comp = `${response.product.partTypes[k].percentage} % ${response.product.partTypes[k].material}`;
                    var type = `</br>${response.product.partTypes[k + 1].type}: `;

                    $container.append(comp);
                    $container.append(type);
                }
            } else {
                var comp = `${response.product.partTypes[k].percentage} % ${response.product.partTypes[k].material} `;
                $container.append(comp);
            }
        }
        const endTag = `</div>`;
        $container.append(endTag);
    } else if (response.product.mainComposition) {
        $container.empty();
        const html = `<div class="comp-material">`;
        $container.append(html);

        for (var k = 0; k < response.product.mainComposition.length; k++) {
            if (k == response.product.mainComposition.length - 1) {
                var comp = `${response.product.mainComposition[k].percentage} % ${response.product.mainComposition[k].material} `;
            } else {
                var comp = `${response.product.mainComposition[k].percentage} % ${response.product.mainComposition[k].material}, `;
            }

            $container.append(comp);
        }
        const endTag = `</div>`;
        $container.append(endTag);
    }

    // Update primary images
    if (imagesShouldUpdate) {
        const primaryImageUrls = response.product.images;
        if ($productContainer.hasClass('product-quickview:not(.product-quickview--get-product)')) {
            if ($productContainer.find('.carousel-inner').hasClass('slick-initialized')) {
                $productContainer.find('.carousel-inner').slick('destroy');
            }
            $productContainer.find('.carousel-inner').empty();
            $productContainer.find('.product-link-carousel').attr('href', response.product.selectedProductUrl);

            primaryImageUrls.large.forEach((imageUrl, idx) => {
                let $carouselInner = $($('#outer').html());
                $productContainer.find('.carousel-inner').append($carouselInner);

                let $imgContainer = $carouselInner.find('img');
                $imgContainer.data('index', idx);
                $imgContainer.attr('id', null);
                $imgContainer.attr('src', imageUrl.url).removeClass('hidden');
            });

            if (Foundation.MediaQuery.atLeast('large')) {
                $productContainer.find('.carousel-inner').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                });
            }
        } else if ($productContainer.hasClass('product-quickview--get-product')) {
            if ($productContainer.find('.carousel-inner').hasClass('slick-initialized')) {
                $productContainer.find('.carousel-inner').slick('destroy');
            }
            $productContainer.find('.carousel-inner').empty();
            $productContainer.find('.product-link-carousel').attr('href', response.product.selectedProductUrl);

            primaryImageUrls.large.forEach((imageUrl, idx) => {
                let $carouselInner = $($('#outer').html());
                $productContainer.find('.carousel-inner').append($carouselInner);

                let $imgContainer = $carouselInner.find('img');
                $imgContainer.data('index', idx);
                $imgContainer.attr('id', null);
                $imgContainer.attr('src', imageUrl.url).removeClass('hidden');
            });

            $productContainer.find('.carousel-inner').slick({
                dots: false,
                arrows: false,
                slidesToShow: 2.35,
                infinite: false,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1023,
                        settings: {
                            slidesToShow: 2.5
                        }
                    }]
            });
        } else {
            $('.mobile-gallery').slick('slickUnfilter');
            $productContainer.find('.primary-images .carousel-item').addClass('hidden');
            $productContainer.find('.js-intProductDetail-images-container .desktop-gallery-item').addClass('hidden');
            $productContainer.find('.cc-intProductDetail-images').addClass('hidden');
            $('#zoomModal').data('numberOfImages', primaryImageUrls.large.length);
            // For each image check if tag is generated otherwise generate it and change its src
            primaryImageUrls.large.forEach((imageUrl, idx) => {
                var resizedUrls = '';
                if (imageUrl.resizedUrls) {
                    var srcSetArray = imageUrl.resizedUrls.map((element, index) => {
                        return element + ' ' + imageUrl.sizes[index].scaleWidth + 'w';
                    });
                    resizedUrls = srcSetArray.join(',');
                }
                let $imgContainer = $productContainer.find('.primary-images').find(`img[data-index="${idx}"]`);
                let $imgContainerDesktop = $productContainer.find('.js-intProductDetail-images-container').find(`img[data-index="${idx}"]`);
                let $imgZoomModal = $productContainer.find('.js-zoomModal').find(`img[data-index="${idx}"]`);
                let $imgZoomModalMobile = $productContainer.find('.js-zoomModalMobile').find(`img[data-index="${idx}"]`);

                if (!$imgContainer.length) {
                    let newCarouselSlideHtml = $('#outer').html().replaceAll('{imgIdx}', idx);
                    $productContainer.find('.primary-images').slick('slickAdd', newCarouselSlideHtml);
                    $imgContainer = $productContainer.find(`.primary-images img[data-index="${idx}"]`);
                }
                if (!$imgContainerDesktop.length) {
                    let $galleryItemContainer = $($('#outer-desktop').html().replaceAll('{imgIdx}', idx));
                    $productContainer.find('.js-intProductDetail-images-container').append($galleryItemContainer);

                    $imgContainerDesktop = $galleryItemContainer.find('img');
                    $imgContainerDesktop.attr('data-index', idx);
                }
                if (!$imgZoomModal.length) {
                    let $zoomTemplate = $($('#zoom-template').html());
                    $productContainer.find('.js-zoomModal-content').append($zoomTemplate);

                    $imgZoomModal = $zoomTemplate.find('img');
                    $imgZoomModal.attr('data-index', idx);
                }

                if (!$imgZoomModalMobile.length) {
                    let $zoomTemplate = $($('#zoom-template').html().replaceAll('{imgIdx}', idx));
                    $productContainer.find('.js-zoomModal-content').append($zoomTemplate);

                    $imgZoomModalMobile = $zoomTemplate.find('img');
                    $imgZoomModalMobile.attr('data-index', idx);
                }

                if (imageUrl.resizedUrls) {
                    $productContainer.find('.primary-images').find(`img[data-index="${idx}"]`).attr('data-srcset', resizedUrls);
                    $productContainer.find('.js-intProductDetail-images-container').find(`img[data-index="${idx}"]`).attr('data-srcset', resizedUrls);
                    if ($imgZoomModal.length) {
                        $imgZoomModal.attr('srcset', resizedUrls).attr('data-srcset', resizedUrls);
                    }
                    if ($imgZoomModalMobile.length) {
                        $imgZoomModalMobile.attr('srcset', resizedUrls).attr('data-srcset', resizedUrls);
                    }
                }
                $imgZoomModalMobile.attr('src', imageUrl.url).attr('data-src', imageUrl.url).removeClass('hidden');
                $imgZoomModal.attr('src', imageUrl.url).attr('data-src', imageUrl.url).removeClass('hidden');
                $productContainer.find(`.cc-intProductDetail-images[data-index="${idx}"]`).removeClass('hidden');
                $productContainer.find('.primary-images').find(`img[data-index="${idx}"]`).attr('src', imageUrl.url).attr('data-src', imageUrl.url).removeClass('lazyloaded').addClass('lazyload');
                $productContainer.find('.js-intProductDetail-images-container').find(`img[data-index="${idx}"]`).attr('src', imageUrl.url).attr('data-src', imageUrl.url).removeClass('lazyloaded').addClass('lazyload');
                $productContainer.find('.primary-images').find(`.carousel-item[data-index=${idx}]`).removeClass('hidden');
                $productContainer.find('.js-intProductDetail-images-container').find(`.desktop-gallery-item[data-index=${idx}]`).removeClass('hidden');
            });
            const videoUrl = response.product.videoURL;
            $('.primary-images .js-productVideoContainer').remove();
            $('.js-intProductDetail-images-container .js-productVideoContainer').remove();
            if (videoUrl) {
                // insert primary video in mobile carousel
                let tmpl = $('.js-productVideoContainerOuter').clone()[0];
                tmpl.setAttribute('class', 'carousel-item cc-productVideoContaner js-productVideoContainer');
                $productContainer.find('.primary-images').slick('slickAdd', tmpl, 2, true);

                // insert primary video in desktop gallery
                tmpl = $($('#pdp-video-template-desktop').html());
                let $secondItem = $productContainer.find('.js-intProductDetail-images-container .desktop-gallery-item')[1];
                tmpl.insertAfter($secondItem);

                $productContainer.find('.js-productVideoContainer source').attr('src', videoUrl);

                let videoBlock = $productContainer.find('.js-productVideoContainer video');
                if (videoBlock && videoBlock.length > 0) {
                    videoBlock[0].load();
                    videoBlock[0].autoplay = true;
                }
                videoListener();
            }
            $('.primary-images').slick('slickGoTo', 0);
            $('.primary-images').slick('slickFilter', ':not(.hidden)');
            if (primaryImageUrls.small.length > 0) {
                $('.still-life-img').data('still-life', primaryImageUrls.small[0].url);
            }

            updatePrimaryImagesSlider(primaryImageUrls.large);
            updateJpMobileImageCarousel(primaryImageUrls.large, $productContainer);
        }
    }

    // Update pricing
    if (response.product.price) {
        updatePrices(response.product, $productContainer, response.resources);
    }

    // Updating available elements
    updateAvailableQuantity(response);

    updateAvailability(response, $productContainer);
    // Enable "Add to Cart" button if all required attributes have been selected
    $('button.js-add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
        product: response.product,
        $productContainer: $productContainer
    }).trigger('product:statusUpdate', response.product);

    if ($('.js-personalizeButtonModal').length == 0) {
        careAndMaintenance(response.product.id);
    }

    var countryEnabled = window.PersonalizationEnabledCountries.PersonalizationEnabledCountries;
    if (response.variation.isPersonalizedVal && response.variation.positions > 0 && countryEnabled) {
        showButton(response);
    } else {
        $('#personalizeButton').addClass('hidden');
    }

    updateModelSize(response, $productContainer);

    if (variantType === 'color') {
        updateSelectedSize();
    }
};

const updateModelSize = (response, $productContainer) => {
    $('.js-product-model-size').addClass('hide');
    var modelSize = response.product.modelSize;
    if (!modelSize) {
        return;
    }

    $('.js-product-model-size').removeClass('hide').find('.js-modelSizeValue').text(modelSize);
};

const handleVariationUrlsSelectSizeModal = (variationUrls) => {
    variationUrls.forEach(function (element) {
        $('#whislistSizeSelection-' + element.id).attr('data-attr-info-url', element.variationUrl);
    });
};
const handlePromotionTag = (product, $productContainer) => {
    const $badgeContainer = $productContainer.find('.marketing-budge-container');
    if (!$badgeContainer.length) return;

    const spritePath = $badgeContainer.data('sprite-path');
    const isLogged = $badgeContainer.data('is-logged');
    const isLoyalty = $badgeContainer.data('is-loyalty');
    const hasCountryLoyalty = $badgeContainer.data('has-country-loyalty');
    const msgLoginRegister = $badgeContainer.data('msg-login-register');
    const msgSignIn = $badgeContainer.data('msg-sign-in');

    const getIconHtml = (symbol, svgClass) => {
        return `
            <i role="presentation">
                <svg class="${svgClass}" aria-hidden="true">
                    <use href="${spritePath}#${symbol}" />
                </svg>
            </i>`;
    };

    // Clean up existing promo badges
    $badgeContainer.find('.js-promo-msg').remove();

    if (product.promotions && product.promotions.length > 0) {
        // Filter first to ensure we only deal with 'PRODUCT' class, matching your old logic
        const productPromos = product.promotions.filter(p => p.promotionClass === 'PRODUCT' && p.calloutMsg || p.plpCalloutMsg);

        // Take the top 3
        const displayedPromos = productPromos.slice(0, 3);

        displayedPromos.forEach((promo) => {
            // Priority: CalloutMsg (standard SFCC) then Name
            const promoTitle = promo.calloutMsg || promo.plpCalloutMsg;
            if (!promoTitle) return;

            const bgColor = promo.tagBackgroundColor ? `style="background-color: ${promo.tagBackgroundColor}"` : '';
            const hasTooltip = promo.details && promo.details.trim().length > 0;

            let tooltipHtml = '';
            if (hasTooltip) {
                let ctaHtml = '';
                if (promo.tooltipCTA) {
                    if (!isLogged) {
                        ctaHtml = `<a href="#" class="js-layer-login js-layer-login-pd cc-tooltip-button">${msgLoginRegister}</a>`;
                    } else if (isLogged && hasCountryLoyalty && !isLoyalty) {
                        ctaHtml = `<a href="#" class="js-modal-loyalty-registration cc-tooltip-button">${msgSignIn}</a>`;
                    }
                }

                tooltipHtml = `
                    <div class="cc-promo-info-tooltip-wrapper" tabindex="0" role="button">
                        ${getIconHtml('thickinfo', 'micro cc-promo-info-icon js-promo-info-icon')}
                        <div class="cc-promo-tooltip js-promo-tooltip hidden">
                            <span class="cc-promo-detail-tooltip">
                                <span class="cc-promo-tooltip-close js-promo-tooltip-close">
                                    ${getIconHtml('close-cross', 'no-margin small')}
                                </span>
                                <span class="cc-promotion-details-title">${promoTitle}</span>
                                <span class="cc-promotion-details-description">${promo.details}</span>
                                ${ctaHtml}
                            </span>
                        </div>
                    </div>`;
            }

            const badgeHtml = `
                <span class="js-promo-msg marketing-budge marketing-budge_promo" data-promotion-id="${promo.id}" ${bgColor}>
                    ${promoTitle}
                    ${tooltipHtml}
                </span>`;

            // Append ensures the "first" promo in the array is the first badge visually
            $badgeContainer.append(badgeHtml);
        });
    }

    initializeTooltips();
};

const handleCustomPromoTags = (promoTagList, $productContainer, level) => {
    var $promoContainer = $productContainer.find('.cc-promo-container');
    if (!$promoContainer.length) return;

    const promoTagClass = '.cc-promo-msg--' + level;
    $promoContainer.find(promoTagClass).remove();

    if (!promoTagList || !promoTagList.length) return;
    promoTagList.forEach(function (tag) {
        const $tag = $('<div class="cc-promo-msg cc-promo-msg--' + level + '"></div>');
        if (tag.inlineStyle) {
            $tag.attr('style', tag.inlineStyle);
        }
        $tag.text(tag.textLabel);
        $promoContainer.append($tag);
    });
};

const handleVariationUrlsSelectNotifyModal = (variationUrls) => {
    variationUrls.forEach(function (element) {
        if ((element.id).indexOf('/') != -1) {
            let cleanId = (element.id).split('/')[0] + '\\/' + (element.id).split('/')[1];
            $('#' + cleanId).attr('data-url', element.variationUrl);
            $('#' + cleanId).parent().attr('sku', element.sku);
            $('.add-size-saveForLater input[data-attr-value="' + cleanId + '"]').parent().removeClass('disabled');
            if (!element.selectable) {
                $('.add-size-saveForLater input[data-attr-value="' + cleanId + '"][data-sku="' + element.sku + '"]').parent().addClass('disabled');
            }
        } else {
            $('#' + element.id).attr('data-url', element.variationUrl);
            $('#' + element.id).parent().attr('data-sku', element.sku);
            $('#' + element.id).attr('data-sku', element.sku);
            $('#' + element.id).attr('data-allocation', element.allocation);
            $('#' + element.id).parent().find('.js-container').removeClass('notifyPopup').removeClass('notifyMe');
            $('#' + element.id + '_mobile').parent().find('.js-container').removeClass('notifyPopup').removeClass('notifyMe');
            $('.js-add-size-saveForLater input[data-attr-value="' + element.id + '"]').parent().removeClass('cc-disabled');
            $('.js-add-size-saveForLater input[data-attr-value="' + element.id + '"]').parent().removeClass('cc-selected');
            if (element.selectable === false) {
                $('.js-add-size-saveForLater input[data-attr-value="' + element.id + '"]').parent().addClass('cc-disabled');
            }
            if (element.selected === true) {
                $('.js-add-size-saveForLater input[data-attr-value="' + element.id + '"]').parent().addClass('cc-selected');
            }
            if (element.allocation === 0 || element.isComingSoon) {
                $('.js-add-size-saveForLater input[data-attr-value="' + element.id + '"]').parent().addClass('cc-disabled');
                $('#' + element.id).parent().find('.js-container').addClass('notifyMe').addClass('notifyPopup');
                $('#' + element.id + '_mobile').parent().find('.js-container').addClass('notifyMe').addClass('notifyPopup');
            }
        }
    });
};

const handleVariationComingSoonNotifyModal = (comingSoons) => {
    comingSoons.forEach(function (element) {
        if ((element.id).indexOf('/') != -1) {
            let cleanId = (element.id).split('/')[0] + '\\/' + (element.id).split('/')[1];
            $('#' + cleanId).attr('data-isComingSoon', element.isComingSoon);
        } else {
            $('#' + element.id).attr('data-isComingSoon', element.isComingSoon);
        }
    });
};
const handleVariationComingSoon = (comingSoons) => {
    if (!comingSoons) {
        $('.marketing-budge.js-comingSoonBox').addClass('hide');
        $('.js-comingSoonBox.pdp-comingSoonBox').addClass('hide');
    } else {
        $('.marketing-budge.js-comingSoonBox').removeClass('hide');
        $('.js-comingSoonBox.pdp-comingSoonBox').removeClass('hide');
    }
};

const handleVariationWishlistModal = (variationUrls) => {
    variationUrls.forEach(function (element) {
        if ((element.id).indexOf('/') != -1) {
            let cleanId = (element.id).split('/')[0] + '\\/' + (element.id).split('/')[1];
            $('#fis-select-size-wishlist').find('#whislistSizeSelection').find('button*[data-attr-value="' + cleanId + '"]').attr('data-attr-info-url', element.variationUrl);
            $('#fis-select-size-wishlist').find('#whislistSizeSelection').find('button*[data-attr-value="' + cleanId + '"]').attr('data-attr-selectable', element.selectable ? 'selectable' : 'not-selectable');
        } else {
            $('#fis-select-size-wishlist').find('#whislistSizeSelection').find('button*[data-attr-value="' + element.id + '"]').attr('data-attr-info-url', element.variationUrl);
            $('#fis-select-size-wishlist').find('#whislistSizeSelection').find('button*[data-attr-value="' + element.id + '"]').attr('data-attr-selectable', element.selectable ? 'selectable' : 'not-selectable');
        }
    });
};

/**
 * This is a workaround for inexisting sizes for the cart's quick view.
 * It should be handled at decorator level but the list of actual variants is incoherent.
 */
const handleInexistentSizeQuickView = (data) => {
    if (!data.product.isSizeInexistent || !$('.quickview-modal').length) {
        return;
    }

    $('.product-content-size').find('input[data-size-id]').removeClass('hide')
        .closest('.boolean-field').removeClass('hide')
        .closest('.label-wrapper').removeClass('hide');
};

function showButton(response) {
    // $('#iconPersMobile').removeClass('hidden');
    if (response.variation.isPersonalizedVal === true) {
        $('#personalizeButton').removeClass('hidden');
    } else {
        $('#personalizeButton').addClass('hidden');
    }
    $('#personalizeButton')
        .attr('product-id', response.product.id)
        .attr('data-positions', response.variation.positions)
        .attr('data-customizations', response.variation.customizations)
        .attr('data-personalizationImgTop', response.variation.personalizationImgTop)
        .attr('data-personalizationImgDown', response.variation.personalizationImgDown);

    var link = $('#personalizeButton').attr('data-url') + '?pid=' + response.product.id +
        '&positions=' + response.variation.positions +
        '&quantity=' + response.product.selectedQuantity;
    $('#personalizeButton a').attr('href', link);
    $('#personalizeButton button').attr('data-url', link);
    $('.js-pers-butt').attr('data-url', link);

    var linkPlp = $('#personalizeButton').attr('data-url') + '?pid=' + response.product.id +
        '&positions=' + response.variation.positions +
        '&quantity=' + response.product.selectedQuantity +
        '&sizeAttribute=' + $('.persButtonPdpPers').attr('size-attribute');

    $('#persButtonPdpPersLink').attr('href', linkPlp);
}

function careAndMaintenance(pid) {
    $('#main-and-care-label-wash-description').removeClass('hidden');
    $('#main-and-care-label').addClass('hidden');

    if (!$('#main-and-care').length) {
        return;
    }

    $.ajax({
        url: $('#main-and-care').attr('data-url'),
        data: {
            pid: pid
        },
        method: 'GET',
        success: data => {
            $('#cm-container').empty().html(data.html);
            $.spinner().stop();
        },
        error: () => {
            $.spinner().stop();
        }
    });
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
const updateQuantities = (quantities, $productContainer) => {
    if (!($productContainer.parent('.bonus-product-item').length > 0)) {
        const optionsHtml = quantities.map((quantity, index) => {
            let selected = quantity.selected ? 'selected' : '';
            
            return `<option value="${quantity.value}"  data-url="${quantity.url}" ${selected}>${quantity.value}</option>`;
        }).join('');
        if ($productContainer.hasClass('product-detail-quick-add')) {
            $('.quantity-select-quick-add').empty().html(optionsHtml);
        } else {
            getQuantitySelector($productContainer).empty().html(optionsHtml);
        }
    }
};

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
const getAddToCartUrl = () => {
    return $('.add-to-cart-url').val();
};

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
const parseHtml = html => {
    var $html = $('<div>').append($.parseHTML(html));

    var body = '';
    let $results = $html.find('.choice-of-bonus-product');
    for (let i = 0; i < $results.length; i++) {
        body += $results[i].outerHTML;
    }
    var footer = $html.find('.modal-footer').children().html();

    return {
        body: body,
        footer: footer
    };
};

// Generates a PID based on the current selected attributes
const getPID = (product) => {
    if (typeof product === 'string') {
        return product.trim();
    }

    // size and color have already been selected. In this case, the variation
    // group is built with the style of the product, 'color' and the selected
    // color variation
    if (product.productType === 'variant') {
        let sku = product.id;
        return sku;
    } else if (product.productType === 'variationGroup') {
        // in this case the user only chose the color, and not the size
        let pid = product.id.split('_')[0].trim();

        let selectedVariation;

        for (let k in product.variationAttributes) {
            const variationAttribute = product.variationAttributes[k];
            if (variationAttribute.attributeId === 'color') {
                for (let j in variationAttribute.values) {
                    if (variationAttribute.values[j].selected === true) {
                        selectedVariation = variationAttribute.values[j].value;
                        break;
                    }
                }
            }
            if (selectedVariation !== undefined) {
                break;
            }
        }

        return pid + '_color_' + selectedVariation;
    }

    return '';
};

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
const handlePostCartAdd = (response) => {
    $('.js-mainHeader-minicart').trigger('count:update', response);

    const cookies = document.cookie.split(';');
    let cookieSizebaySessionId = null;
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith('SIZEBAY_SESSION_ID_V4')) {
            cookieSizebaySessionId = cookie.substring('SIZEBAY_SESSION_ID_V4='.length).replaceAll('"', '');
            break;
        }
    };

    if (cookieSizebaySessionId === null) {
        let urlSessionId = document.querySelector('#sizebayAddProduct').getAttribute('data-sizebaysessionidurl');
        fetch(urlSessionId)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                createCookie('SIZEBAY_SESSION_ID_V4', data);
                callSizebayAPI(data);
            })
    } else {
        callSizebayAPI(cookieSizebaySessionId);
    }
};

function callSizebayAPI(data) {
    let url = document.querySelector('#sizebayAddProduct').getAttribute('data-sizebay-link') + '=' + data;
    let brandURL = document.querySelector('#sizebayAddProduct').getAttribute('data-referrer-sizebay-link');
    let currentCountry = document.querySelector('#sizebayAddProduct').getAttribute('data-sizebay-locale');
    if (!brandURL.includes(currentCountry)) {
        brandURL += '/' + currentCountry + '/';
    }
    let permaURL = brandURL + document.querySelector('.analytics.product.hidden').getAttribute('data-item_id');
    let urlSizebay = new URL(url);
    if (urlSizebay.searchParams.has('sid') && urlSizebay.searchParams.get('sid') === 'null') {
        urlSizebay.searchParams.set('sid', data.trim().replace(/^"|"$/g, ''));
        url = urlSizebay.toString();
    }
    let payload = JSON.stringify({
        "products": [
            {
                "permalink": permaURL
            }
        ],
        "tenantId": 2399
    });

    let device = $('.cc-intProductDetail-left-content .cell .js-intProductDetail-images-container.cc-intProductDetail-images-container').css('display') === 'block' ? 'mobile' : 'desktop';
    let referrerURL = new URL(window.location.href);
    try {
        fetch(url, {
            method: 'POST',
            body: payload,
            referrerPolicy: "origin-when-cross-origin",
            headers: {
                "content-type": "application/json",
                accept: "application/json",
                tenant_id: '2399',
                device: device,
                referer: referrerURL.hostname
            }
        });
    } catch (error) {
        console.error("Error: ", error);
    }
}

function updateQuantityPicker(source, availableQuantity) {
    if (source === null || source.closest('.js-pdpStickyBar').length > 0 || source.closest('.js-customizePage').length > 0) {
        source = $('.attribute-container.quantity');
    } else {
        source = source.closest('.attribute-container.quantity');
    }
 
    let value = parseInt(source.find('.js-quantity-value').html());
 
    if (availableQuantity && value >= availableQuantity) {
        source.find('.js-quantity-button[data-action="increase"]').addClass('disabled');
        source.find('.js-quantity-button[data-action="decrease"]').removeClass('disabled');
        if ($('.js-pdpStickyBar').length > 0) {
            $('.js-pdpStickyBar .js-quantity-button[data-action="increase"]').addClass('disabled');
            $('.js-pdpStickyBar .js-quantity-button[data-action="decrease"]').removeClass('disabled');
        }
    } else if (value === 10) {
        source.find('.js-quantity-button[data-action="increase"]').addClass('disabled');
        source.find('.js-quantity-button[data-action="decrease"]').removeClass('disabled');
        if ($('.js-pdpStickyBar').length > 0) {
            $('.js-pdpStickyBar .js-quantity-button[data-action="increase"]').addClass('disabled');
            $('.js-pdpStickyBar .js-quantity-button[data-action="decrease"]').removeClass('disabled');
        }
    } else if (value === 1) {
        source.find('.js-quantity-button[data-action="decrease"]').addClass('disabled');
        source.find('.js-quantity-button[data-action="increase"]').removeClass('disabled');
        if ($('.js-pdpStickyBar').length > 0) {
            $('.js-pdpStickyBar .js-quantity-button[data-action="decrease"]').addClass('disabled');
            $('.js-pdpStickyBar .js-quantity-button[data-action="increase"]').removeClass('disabled');
        }
    } else {
        source.find('.js-quantity-button[data-action="increase"]').removeClass('disabled');
        source.find('.js-quantity-button[data-action="decrease"]').removeClass('disabled');
        if ($('.js-pdpStickyBar').length > 0) {
            $('.js-pdpStickyBar .js-quantity-button[data-action="increase"]').removeClass('disabled');
            $('.js-pdpStickyBar .js-quantity-button[data-action="decrease"]').removeClass('disabled');
        }
    }
}

const calculateWatchedTime = (video) => {
    let percentageWatched = video.currentTime * 100 / video.duration;
    return percentageWatched;
};

const triggerVideoInteractionEvent = (action, fullPageLoad) => {
    $('body').trigger('analytics:videoInteraction', { action: action, fullPageLoad: fullPageLoad });
};

const videoListener = (fullPageLoad = false) => {
    const $videoBlockContainer = $('.js-productVideoContainer');
    const $videoPlayMiniatureIcon = $('.productVideoMiniatureMobile.js-productVideoMiniatureMobile').find('.videoMiniatureIcon');
    let percentageWatched = 0;
    let firstPlayback = true;
    let watchedFullVideo = false;
    let videoStartInSeconds = 0;
    let videoEndInSeconds = 0;
    if ($videoBlockContainer.length > 0 && !$videoBlockContainer.hasClass('hidden')) {
        var myVideo = $videoBlockContainer.find('video')[0];
        myVideo.onended = function () {
            myVideo.currentTime = 0;
        };
        myVideo.onplaying = function () {
            if (myVideo.autoplay) {
                triggerVideoInteractionEvent('auto_play', fullPageLoad);
            }
            myVideo.autoplay = false;
        };
        myVideo.onpause = function () {
            if (!firstPlayback) {
                watchedFullVideo = videoEndInSeconds - videoStartInSeconds > myVideo.duration;
                triggerVideoInteractionEvent('pause', fullPageLoad);
                if (watchedFullVideo) {
                    triggerVideoInteractionEvent('full_view', fullPageLoad);
                } else if (percentageWatched >= 25 && percentageWatched < 50) {
                    triggerVideoInteractionEvent('view25', fullPageLoad);
                } else if (percentageWatched >= 50 && percentageWatched < 75) {
                    triggerVideoInteractionEvent('view50', fullPageLoad);
                } else if (percentageWatched >= 75 && percentageWatched < 100) {
                    triggerVideoInteractionEvent('view75', fullPageLoad);
                } else if (percentageWatched === 100) {
                    triggerVideoInteractionEvent('full_view', fullPageLoad);
                }
            }
            firstPlayback = false;
        };
        $('.js-pauseVideoIcon').on('click', function () {
            myVideo.loop = false;
            percentageWatched = calculateWatchedTime(myVideo);
            videoEndInSeconds = new Date().getTime() / 1000;
            myVideo.pause();
            myVideo.currentTime = 0;
            $videoBlockContainer.find('.js-pauseVideoIcon').addClass('hide');
            $videoBlockContainer.find('.js-playVideoIcon').removeClass('hide');
            $videoPlayMiniatureIcon.removeClass('black-border');
        });
        $('.js-playVideoIcon').on('click', function () {
            myVideo.loop = true;
            $videoBlockContainer.find('.js-pauseVideoIcon').removeClass('hide');
            $videoBlockContainer.find('.js-playVideoIcon').addClass('hide');
            $videoPlayMiniatureIcon.addClass('black-border');
            if (myVideo.paused && !myVideo.autoplay) {
                triggerVideoInteractionEvent('play', fullPageLoad);
            }
            videoStartInSeconds = new Date().getTime() / 1000;
            myVideo.play();
        });
    }
};

/**
 * reorder the swatches in $swatchContainer in order to push the soldout ones at the end
 */
const reorderSwatches = ($swatchContainer) => {
    if ($swatchContainer.find('span.swatch-value.soldout').length === 0) {
        return;
    }
    var $soldoutColorsContainers = $swatchContainer.find('span.swatch-value.soldout').closest('div');
    var $lastNonSoldoutColorContainer = $swatchContainer.find('span.swatch-value').closest('div').not($soldoutColorsContainers).last();
    $soldoutColorsContainers.insertAfter($lastNonSoldoutColorContainer);
};

const showPromoMessage = (data) => {
    var promoContainer = $('.js-promo-loyalty-message-pdp-underprice');
    if (promoContainer.length > 0) {
        let promoFound = false;
        if (data.product.promotions && data.product.promotions.length > 0) {
            for (var i = 0; i < data.product.promotions.length; i++) {
                var promo = data.product.promotions[i];
                if (promo.promoLoyaltyMessage) {
                    promoContainer.replaceWith(promo.promoLoyaltyMessage);
                    promoFound = true;
                    break;
                }
            }
        }
        if (!promoFound) {
            promoContainer.html('');
            promoContainer.addClass('hide');
        }
    }
}

class ProductHelpers {
    constructor() {
        this.freeGiftDetailsModal = 'freeGiftDetailsModal';
        this.bonusProductModal = null;
        this.methods = {
            getPidValue: function ($el) {
                return getPidValue($el);
            }
        };
    }

    run() {
        this.colorAttribute();
        this.colorAttributeQuickAddListing();
        this.sizeAttribute();
        this.sizeAttributeQuickAddListing();
        this.sizeAttributeQuickAddPDP();
        this.sizeAttributeSet();
        this.quantity();
        this.availability();
        this.addToCart();
        // this.selectBonusProduct();
        // this.removeBonusProduct();
        // this.enableBonusProductSelection();
        // this.showMoreBonusProducts();
        // this.closeBonusProductModal();
        // this.enableAddAfterBonusColorSelection();
        // this.removeSizePickerPopup();
        // this.addBonusProductsToCart();
        // this.handleBonusSize();
        // this.handleBonusColor();
        // this.removeColorPickerPopup();
        this.careAndMaintenanceClick();
        this.personalizationListeners();
        this.sizeTU();
        this.quickAddListener();
        videoListener(true);
        NotifyHelper.notifyMeModal();
        this.checkSoldoutAvailability();
        SmartGiftHelper.run();
        sizePanel.init();
        this.registerAttributionTokenSending();
        this.loadGoogleRecommendations();
    }

    personalizationListeners() {
        $('body').on('click', '.persButt', (e) => {
            e.preventDefault();
            let persButton = e.currentTarget;
            // Simulate disabled button with class to allow click and event
            if ($(e.currentTarget).data('disabled') || !this.isSizeSelected()) {
                
                // If no size is selected, open modal to choose one

                if ($(e.currentTarget).closest('.quickview-modal').length) {
                    // QuickView (Open the other modal type)

                    let modal = $('.js-modal-quick-size-quantity');
                    // First check if it is open
                    if (modal.hasClass('open')) {
                        // Check if size is selected, then add to cart
                    } else {
                        // Show it
                        modal.removeClass('hidden').addClass('open');
                        modal.find('.slick-slider.slick-initialized').slick('refresh');

                        modal.find('.js-close-select-size').on('click', function (e) {
                            modal.addClass('hidden').removeClass('open');
                        });
                    }
                } else if (!($(e.currentTarget).hasClass('persButtMobile') && !$('.pdp-buy-look-container').hasClass('hidden'))) {
                    sizePanel.openSizePanel(sizePanel.Types.PERSONALIZE);
                }

                // Prevent further progress until a size is selected
                e.preventDefault();
            } else {
                if ($('.jsPersonalizationToolModal').length === 0) {
                    let url = $(e.currentTarget).attr('data-url') || $(e.currentTarget).data('url');
                    $.get(url, function (data) {
                        if (data && data !== '') {
                            let modal = newModalFromString(data, true, ['jsPersonalizationToolModal'], () => {
                                // TODO: On Open Actions
                                $('.tingle-modal .close').on('click touchstart', function (e) {
                                    e.preventDefault();
                                    modal.close();
                                    modal.destroy();
                                });
                                $('.js-customize-colors').on('scroll', throttle(function () {
                                    const carouselWidth = $(this)[0].clientWidth;
                                    const scrollWidth = $(this)[0].scrollWidth;
                                    const carouselScrolled = Math.abs($(this).scrollLeft());
                                    if (carouselScrolled < 5) {
                                        $(this).closest('.cc-em').find('.js-carouselCustom__arrowRight').addClass('cc-disabled');
                                        $(this).closest('.cc-em').find('.js-carouselCustom__arrowLeft').removeClass('cc-disabled');
                                    } else if (carouselScrolled >= (scrollWidth - carouselWidth - 5)) {
                                        $(this).closest('.cc-em').find('.js-carouselCustom__arrowLeft').addClass('cc-disabled');
                                        $(this).closest('.cc-em').find('.js-carouselCustom__arrowRight').removeClass('cc-disabled');
                                    } else {
                                        $(this).closest('.cc-em').find('.js-carouselCustom__arrowLeft').removeClass('cc-disabled');
                                        $(this).closest('.cc-em').find('.js-carouselCustom__arrowRight').removeClass('cc-disabled');
                                    }
                                }, 200, { trailing: true }));
                            }, () => {
                                // TODO: On Close Actions
                                $('[data-attr="size"] input.js-mobile-size-selected').prop('checked', true);
                                persButton.blur();
                            });
                            $(modal.modalBox).addClass('rightModalAttribute cc-detailsPopup-modalBox rightModalAttribute_sizeXtraLarge');
                            // close size panel after cofirming size for personalization
                            $('.js-size-selector-mobile-modal').click();
                            modal.open();
                            runPersonalizationListener();
                        }
                    });
                }
            }
        });
        $('body').on('click', '.js-personalize-control', (e) => {
            $('.js-personalize-control-target').addClass('d-none');
            $('.js-personalize-control').removeClass('cc-control-option-selected');
            $(e.currentTarget).addClass('cc-control-option-selected');
            $($(e.currentTarget).data('controlTarget')).removeClass('d-none');
        });

        $('.js-char-counter').text('0/' + $('.js-input-type1').prop('maxlength'));
        $('body').on('input', '.js-input-type1', function () {
            const maxLength = this.maxLength;
            const currentLength = this.value.length;
            $(this).siblings('.js-char-counter').text(currentLength + '/' + maxLength);
        });

        $('body').on('click', '.js-clear-input', function () {
            var $input = $(this).siblings('.js-input-type1');
            $input.val('');
            var $charCounter = $(this).siblings('.js-char-counter');
            $charCounter.text('0/' + $input.prop('maxlength'));
            $(this).addClass('hidden');
            $charCounter.removeClass('hidden');
            $('.content-input-err-cyrillic').addClass('hidden');
            $('.content-input-err').addClass('hidden');
            $input.closest('.cc-contentInput').removeClass('flag-error');
            $input.trigger('input');
        });

        $('body').on('click', '.js-customization-color-select', (e) => {
            const $colorElement = $(e.currentTarget);
            const $colorsContainer = $('.js-customize-colors');
            const $arrows = $('.js-section-module_result .js-em__carouselCustom__arrows');

            if ($colorElement.hasClass('cc-selected')) {
                $colorsContainer.toggleClass('cc-expanded');
                if (!$colorsContainer.hasClass('cc-expanded')) {
                    $arrows.removeClass('cc-visible');
                    $colorsContainer.scrollLeft(0);
                }
            } else {
                $.spinner().start();
                const variationUrl = $colorElement.data('url');
                $.get(variationUrl, (data) => {
                    if (data && data !== '') {
                        const $allColorElements = $('.js-customization-color-select');
                        $allColorElements.removeClass('cc-selected');
                        $colorsContainer.removeClass('cc-expanded');
                        $colorElement.addClass('cc-selected');
                        $arrows.removeClass('cc-visible');
                        $colorsContainer.scrollLeft(0);
                        handleVariationGroupChange(data);
                    }
                }).always(() => {
                    $.spinner().stop();
                });
            }
        });

        $('body').on('mouseenter', '.js-customize-colors-wrapper', () => {
            const $colorsContainer = $('.js-customize-colors');
            const $arrows = $('.js-section-module_result .js-em__carouselCustom__arrows');
            if ($colorsContainer.length) {
                const carouselWidth = $colorsContainer[0].clientWidth;
                const scrollWidth = $colorsContainer[0].scrollWidth;

                if (scrollWidth > carouselWidth) {
                    $arrows.addClass('cc-visible');
                    // Force state update for disabled arrows
                    $colorsContainer.trigger('scroll');
                }
            }
        }).on('mouseleave', '.js-customize-colors-wrapper', () => {
            $('.js-section-module_result .js-em__carouselCustom__arrows').removeClass('cc-visible');
        });

        $('body').on('click', '.js-carouselCustom__arrowLeft, .js-carouselCustom__arrowRight', (e) => {
            e.preventDefault();
            const $arrow = $(e.currentTarget);

            if ($arrow.hasClass('cc-disabled')) return;

            const $colorsContainer = $('.js-customize-colors');
            if (!$colorsContainer.length) return;

            const scrollAmount = 150; // You can adjust this value to change how many pixels it scrolls per click
            const currentScroll = $colorsContainer[0].scrollLeft;

            if ($arrow.hasClass('js-carouselCustom__arrowLeft')) {
                $colorsContainer[0].scrollTo({ left: currentScroll - scrollAmount, behavior: 'smooth' });
            } else {
                $colorsContainer[0].scrollTo({ left: currentScroll + scrollAmount, behavior: 'smooth' });
            }
        });
    }

    careAndMaintenanceClick() {
        $(document).on('click', '.js-caremaintenance-container ul.tabs li', function () {
            $('.js-caremaintenance-container ul.tabs li').removeClass('current');
            $('.tab-content').removeClass('current');
            $(this).addClass('current');
            const description = $(this).data('tab');
            $(`#${description}`).addClass('current');
        });
    }

    colorAttribute () {
        $('body').on('click', '[data-attr="color"] a', e => {
            e.preventDefault();
            const $swatchesContainer = $(e.currentTarget).closest('.js-intProductDetail-colors-wrapper');
            var clickedSwatchIndex = 0;
            if ($swatchesContainer.length) {
                const $allColorSwatchesInContainer = $swatchesContainer.find('.js-select-color-variation');
                clickedSwatchIndex = $allColorSwatchesInContainer.index($(e.currentTarget));
            }
            const viewAllButtonBackground = $(e.currentTarget).find('.js-add-view-more-background').hasClass('js-show-view-more');
            const viewAllButton = $(e.currentTarget).find('.js-view-more-colors-button').hasClass('js-show-view-more');
            const viewAllButtonPlacement = document.querySelector('#jsGetViewAllImagePlacment').getAttribute('data-view-all-placement');
            var colorWithViewAllButton = -1;
            if (viewAllButtonPlacement && viewAllButtonPlacement.length > 0) {
                colorWithViewAllButton = parseInt(viewAllButtonPlacement) - 1;
            }
            if (viewAllButtonBackground && viewAllButton && clickedSwatchIndex === colorWithViewAllButton) {
                $('.js-add-view-more-background').removeClass('js-show-view-more').slideUp(300);
                $('.js-view-more-colors-button').removeClass('js-show-view-more').slideUp(300);
                $('.js-add-view-more-background').addClass('hide');
                $('.js-view-more-colors-button').addClass('hide');
                $('.js-show-view-less').removeClass('hide').slideDown(300);
                $('.js-hide-more-chips').removeClass('hide').slideDown(300);
                return;
            }
            if ($(e.currentTarget).attr('disabled') || ($(e.currentTarget).find('.swatch-value').hasClass('selected'))) {
                return;
            }
            var $productContainer = $(e.currentTarget).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(e.currentTarget).closest('.product-detail');
            }

            if (!$productContainer.length && $(e.currentTarget).hasClass('saveToLater')) {
                $productContainer = $('.wishlist-product-card').closest('.product-detail');
            }

            let imagesShouldUpdate = true;
            if ($productContainer.hasClass('cart-line-item')) {
                imagesShouldUpdate = false;
            }
            attributeSelect($(e.currentTarget).data('url'), $productContainer, 'color', imagesShouldUpdate);
            let color = $productContainer.prevObject.children('span').data('attr-value');
            var firstPart = $productContainer.attr('data-pid');
            var firstPartSplit = firstPart.split('_');
            var firstPartSKU = '';
            if (firstPartSplit.length > 1) {
                firstPartSKU = firstPartSplit[0];
            } else {
                firstPartSKU = firstPart;
            }

            var sku = null;
            let splitSku = firstPartSKU ? firstPartSKU.replace(/\s+/g, '_').split('_') : [];
            let productId = splitSku[0];

            if ($('.page[data-action="Product-Show"]').length > 0) {
                let size = $('.selected-size-value').first().text().trim();
                $('#analyticsSelectedColor').val(color);

                sku = size && size !== 'false' ? productId + '_' + color + '_' + size : productId + '_' + color;
                if (dataLayer && dataLayer[0]) {
                    var wSetupEvent = dataLayer[0];
                    dataLayer.push(wSetupEvent);
                }
                $('body').trigger('product:didChangeColor', { sku: sku });
            } else if ($('.page[data-action="Cart-Show"]').length > 0) {
                let selectedSize = $('.cc-cartQuickView_selectedSize').attr('for');
                let colorValue = $(e.currentTarget).data('color-value');
                $('#analyticsSelectedColor').val(colorValue);

                sku = selectedSize ? productId + '_' + colorValue + '_' + selectedSize : productId + '_' + colorValue;
                if (dataLayer && dataLayer[0]) {
                    var wSetupEvent = dataLayer[0];
                    dataLayer.push(wSetupEvent);
                }
                $('body').trigger('product:didChangeColor', { sku: sku });
            }
            getInitalProductColor($(e.currentTarget));
        });

        $('body').on('click', '.product-detail [data-attr="color"] a', e => {
            if ($(e.currentTarget).parents('.quickview-modal').length !== 0) {
                return;
            }
            // Get new color to push to query string
            var selectedColor = $(e.currentTarget).data('color-value');
            if (!selectedColor) {
                return;
            }
            // Perform URL query string update
            updateProductDetailUrl('_col_', selectedColor);
        });
    }

    colorAttributeQuickAddListing() {
        $('body').on('click', '[data-attr="color-listing"] a', e => {
            e.preventDefault();
            if ($(e.currentTarget).attr('disabled') || $(e.currentTarget).find('.swatch-value').hasClass('selected')) {
                return;
            }

            var url = $(e.currentTarget).attr('href');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'GET',
                success: function (data) {
                    const $productTile = $(e.target).closest('.product-tile-cell');
                    $productTile.html(data);
                    startCarouselTileImageFunction($productTile.find('.js-tileImageCarousel'));
                    $('body').trigger('product:didChangeColor');
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    }

    sizeAttribute() {
        $('body').on('change', '[data-attr="size"] input', e => {
            e.preventDefault();
            $('.size-available').attr('available', true);
            const selectedValue = $(e.currentTarget).attr('value');
            $('#size').attr('size-attribute', $(e.currentTarget).attr('data-attr-value'));
            $('.persButtonPdpPers').attr('size-attribute', $(e.currentTarget).attr('data-attr-value'));
            if (selectedValue === 'null') {
                return;
            }

            let $productContainer = $(e.currentTarget).closest('.set-item');
            if (!$productContainer.length) {
                if ($(e.currentTarget).hasClass('js-add-size-saveForLater')) {
                    var sku = $(e.currentTarget).data('sku');
                    $productContainer = $(e.currentTarget).closest('.cart-line-item-sku-' + sku);
                } else {
                    $productContainer = $(e.currentTarget).closest('.product-detail');
                }
            }
            if ($(e.currentTarget).closest('.product-quickview') && $(e.currentTarget).closest('.product-quickview').length) {
                $('.selectSizeQuickView').removeClass('toSelect');
            }
            if ($(e.currentTarget).closest('.js-complete-your-promo-quick-view')) {
                $(e.currentTarget).closest('.js-complete-your-promo-quick-view').find('.add-to-cart-global').data('disabled', false);
            }

            let ignoreCTA = $('.js-prod-select-size-modal').length && !Foundation.MediaQuery.atLeast('large');
            let isPdp = $('.page').data('action') && $('.page').data('action').toLowerCase().indexOf('product-show') > -1;
            let isPeronalizePage = $('#personalize-page');
            if (isPdp && isPeronalizePage) {
                $productContainer = $('.js-intProductDetail');
            }
            if ($('.js-complete-your-promo-quick-view').length > 0) {
                $productContainer = $('.js-complete-your-promo-quick-view');
            }
            if (isPdp && $('.js-prod-select-size-modal').length || isPeronalizePage && $('.js-prod-select-size-modal').length) {
                ignoreCTA = false;
            }

            let imagesShouldUpdate = true;
            if ($productContainer.hasClass('cart-line-item') || $productContainer.hasClass('js-complete-your-promo-quick-view')) {
                imagesShouldUpdate = false;
            }
            attributeSelect(selectedValue, $productContainer, 'size', imagesShouldUpdate, ignoreCTA);
            var sizeData = $(e.currentTarget).data('attr-value');
            var skuData = $productContainer.data('variant-pid');
            skuData = skuData ? decodeURI(skuData).replace(/\s+/g, '_') : '';

            let color = $('#analyticsSelectedColor').val();
            let splitSkuData = skuData ? skuData.split('_') : [];

            skuData = splitSkuData.length >= 2 && color.trim().length > 0 ? splitSkuData[0] + '_' + color : skuData;

            if ($('.page[data-action="Product-Show"]').length > 0) {
                $('body').trigger('product:didChangeSize', { size: sizeData, sku: skuData });
            } else if ($('.page[data-action="Cart-Show"]').length > 0) {
                $('body').trigger('product:didChangeSize', { size: sizeData, sku: skuData });
            }
        });
        $('body').on('keydown', '.js-container', function (e) {
            if (e.key === 'Enter' || e.which === 13 || e.key === ' ' || e.which === 32) {
                e.preventDefault();
                $(e.currentTarget).trigger('click');
            }
        });
        $('body').on('change', '[data-attr="size-mobile"] input', e => {
            e.preventDefault();
            $("[data-attr='size-mobile'] input")
                .removeClass('js-mobile-size-selected')
                .closest('.js-intProductDetail-size-item')
                .removeClass('cc-intProductDetail-size-item_selected');
            $(e.currentTarget)
                .addClass('js-mobile-size-selected')
                .closest('.js-intProductDetail-size-item')
                .addClass('cc-intProductDetail-size-item_selected');
            let selectedSize = $(e.currentTarget).data('size-id');
            let $sizeSelectedeElem = $(`[data-size-id="${selectedSize}"]`);
            $sizeSelectedeElem.each(function (element) {
                $(this).closest('.js-intProductDetail-size-item').addClass('cc-intProductDetail-size-item_selected');
            });
            $('js-sizeBox-openPanel').attr('');
            $('.js-selectedSizeMobile').text($(e.currentTarget).data('size-value'));
            $('#product-error-msg-mobile').addClass('invisible');
            $('#product-error-msg').hide();
            $('.js-size-selector-mobile-modal .js-linkMobileModalConfirmSize').removeAttr('disabled');
            if ($('#size-panel-mobile').data('operation') === 'wishlist') {
                $('.js-mobile-wishlist-select-label').addClass('hidden');
                $('.js-mobile-wishlist-label').removeClass('hidden');
            }
        });
        $('body').on('click', '.js-linkMobileModalConfirmSize', e => {
            let $sizeSelected = $("[data-attr='size-mobile'] input.js-mobile-size-selected");
            $('.size-available').attr('available', true);
            const selectedValue = $sizeSelected.attr('value');
            $('#size').attr('size-attribute', $sizeSelected.attr('data-attr-value'));
            $('.persButtonPdpPers').attr('size-attribute', $sizeSelected.attr('data-attr-value'));
            if (selectedValue === undefined || selectedValue === null || selectedValue === 'null') {
                $('#product-error-msg-mobile').removeClass('invisible');
                return;
            }
            $('#product-error-msg-mobile').addClass('invisible');

            let $productContainer = $sizeSelected.closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $sizeSelected.closest('.product-detail');
            }
            if ($sizeSelected.closest('.product-quickview') && $sizeSelected.closest('.product-quickview').length) {
                $('.selectSizeQuickView').removeClass('toSelect');
            }

            let ignoreCTA = $('.js-prod-select-size-modal').length && !Foundation.MediaQuery.atLeast('large');
            let isPdp = $('.page').data('action') && $('.page').data('action').toLowerCase().indexOf('product-show') > -1;
            let isPeronalizePage = $('#personalize-page');
            if (isPdp && $('.js-prod-select-size-modal').length || isPeronalizePage && $('.js-prod-select-size-modal').length) {
                ignoreCTA = false;
            }

            let imagesShouldUpdate = true;
            if ($productContainer.hasClass('cart-line-item')) {
                imagesShouldUpdate = false;
            }
            attributeSelect(selectedValue, $productContainer, 'size', imagesShouldUpdate, ignoreCTA);
            var sizeData = null;
            var skuData = null;
            if ($('.page[data-action="Product-Show"]').length > 0) {
                sizeData = $sizeSelected.attr('data-attr-value');
                skuData = $productContainer.data('master-pid');
            }
            $('body').trigger('product:didChangeSize', { size: sizeData, sku: skuData });
        });
        $('body').on('change', '[data-attr="size"] input', e => {
            e.preventDefault();
            $("[data-attr='size'] input")
                .removeClass('js-mobile-size-selected')
                .closest('.js-intProductDetail-size-item')
                .removeClass('cc-intProductDetail-size-item_selected');
            $(e.currentTarget)
                .addClass('js-mobile-size-selected');
            let selectedSize = $(e.currentTarget).data('size-id');
            let $sizeSelectedeElem = $(`[data-size-id="${selectedSize}"]`);
            $sizeSelectedeElem.each(function (element) {
                $(this).closest('.js-intProductDetail-size-item').addClass('cc-intProductDetail-size-item_selected');
            });
            $('#product-error-msg').hide();
        });
    }

    sizeAttributeQuickAddListing() {
        $('body').on('click', '.quick-buy-sizes-item', function (e) {
            e.preventDefault();

            const selectedValue = $(e.currentTarget).data('url');
            if (selectedValue === 'null') {
                return;
            }

            let $productContainer = $(e.currentTarget).closest('.product-tile');
            let imagesShouldUpdate = true;
            if ($productContainer.hasClass('cart-line-item')) {
                imagesShouldUpdate = false;
            }
            attributeSelect(selectedValue, $productContainer, 'size', imagesShouldUpdate, true);
            $('body').trigger('product:didChangeSize');
        });

        $('body').on('quickBuy:addToCart', function (e, data) {
            if (!$('.modal-size-show').length) {
                return;
            }

            $('.modal-size-show').find('.js-add-to-cart').data('pid', data.product.id).trigger('click');
            $('body').trigger('quickBuy:afterAddToCart');
        });
    }

    sizeAttributeQuickAddPDP() {
        if ($('.page').data('action') !== 'Product-Show') {
            return;
        }
        $('body').on('click', '.js-quick-buy-sizes-item-pdp', function (e) {
            e.preventDefault();
            if ($(this).hasClass('disable') || !$(this).data('variant')) {
                return false;
            }

            var url = $(this).data('variant');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                success: function (response) {
                    $.spinner().stop();
                    const $productContainer = $(e.target);

                    // For minicart promo carousel
                    var promotionId = $productContainer.closest('.product').find('.promotion-info-plp').data('promo-id') || false;

                    if (response.product.available && !response.product.comingSoon) {
                        addToCartFromListing(response.product.id, promotionId, $productContainer);
                    } else {
                        $('body').trigger('product:afterAddToCartFailed', {
                            ...response,
                            $productContainer
                        });
                    }
                },
                error: function (err) {
                    console.error('ErrorCase: ' + err.message);
                    $.spinner().stop();
                }
            });
        });
    }

    sizeAttributeSet() {
        $('.set-size').on('click', function (e) {
            $($(e.currentTarget).closest('.product-content-size')[0]).children('.set-size').children('.radio-label-set').removeClass('setsize-selected');
            $(e.currentTarget).children('.radio-label-set').addClass('setsize-selected');
            const selectedValue = e.currentTarget.children[0].value;
            if (selectedValue === 'null') {
                return;
            }

            var $productContainer = $(e.currentTarget).closest('.product-detail');
            attributeSelect(selectedValue, $productContainer, 'size', false);

            $('body').trigger('product:didChangeSize');
        });
    }

    isSizeSelected() {
        if ($('.page-checkout').length > 0 || $('.cart-page').length > 0 || $('.modal-size-show').length > 0 || isMiniCartOpen()) {
            return true;
        }
        return $('[data-attr="size"] input:checked').length > 0;
    };

    quantity() {
        updateQuantityPicker(null);

        $('body').on('click', '.js-quantity-button', function (e) {
            const $button = $(this);
            var $target = $button.closest('.quantity').find('.js-quantity-value');
            var $input = $button.closest('.quantity').find('.quantity-select');
            if ($button.hasClass('js-quantity-button-quick-add')) {
                $target = $button.closest('.quantity').find('.js-quantity-value-quick-add');
                $input = $button.closest('.quantity').find('.quantity-select-quick-add');
            }
            var maxQuantity = $('.js-intProductDetail-size-item input:checked').lenght > 0 ? Math.min($('.js-intProductDetail-size-item input:checked').data('allocation'), 10) : 10;
            const value = parseInt($target.text());
            if ($button.data('action') === 'increase' && value < maxQuantity && !$button.hasClass('disabled')) {
                let newValue = value + 1;
                $('.js-quantity-value').text(newValue);
                $input.val(newValue);

                $('.update-cart-url').data('selected-quantity', newValue);
                $(`[data-opener="QNT"] .attribute-selection`).html(newValue);

                updateQuantityPicker($button);
                $input.trigger('change');
            } else if ($button.data('action') === 'decrease' && value > 1 && !$button.hasClass('disabled')) {
                let newValue = value - 1;
                $('.js-quantity-value').text(newValue);
                $input.val(newValue);
                $('.update-cart-url').data('selected-quantity', newValue);
                $(`[data-opener="QNT"] .attribute-selection`).html(newValue);

                updateQuantityPicker($button);
                $input.trigger('change');
            }
        });
    }

    availability() {
        $('body').on('change', '.quantity-select', e => {
            e.preventDefault();

            var $productContainer = $(e.currentTarget).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(e.currentTarget).closest('.modal-content').find('.product-quickview');
            }
            if (!$productContainer.length) {
                $productContainer = $(e.currentTarget).closest('.product-tile-modal');
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                attributeSelect($(e.currentTarget).find('option:selected').data('url'),
                    $productContainer, '_', false);
            }
        });
        $('body').on('change', '.quantity-select-quick-add', e => {
            e.preventDefault();

            var $productContainer = $(e.currentTarget).closest('.product-detail-quick-add');
            if ($('.bundle-items', $productContainer).length === 0) {
                attributeSelectQuickAdd($(e.currentTarget).find('option:selected').data('url'),
                    $productContainer, '_', false);
            }
        });
    }

    addToCart() {
        $('body').on('click', 'button.js-add-to-cart, button.add-to-cart-global, button.js-add-to-cart-multipack, button.js-mobile-size-add-to-cart', (e) => {
            if ($('#size-panel-mobile').data('operation') === 'wishlist') {
                return;
            }
            const _openStickySizeSelectorModal = (target) => {
                if ($(e.currentTarget).hasClass('add-to-cart-multipack')) {
                    sizePanel.openSizePanel(sizePanel.Types.ADDTOCART_BUNDLE);
                } else if ($(e.currentTarget).closest('.js-pdpStickyBar').length > 0) {
                    $('.js-pdpStickyBar-select').addClass('cc-sizeBox-isOpen');
                } else {
                    if ($('.cc-intProductDetail-size-item_selected').length === 0) {
                        $('#product-error-msg-mobile').removeClass('invisible');
                    }
                    sizePanel.openSizePanel(sizePanel.Types.ADDTOCART);
                }
                $('.pdp-size-box .js-sizeBox-openPanel').addClass('cc-sizeBox-openPanel_error');
                $('#product-error-msg').show();
                $('.pdp-size-box .js-sizeBox-openPanel').attr('aria-invalid', 'true');
            };

            let addToCartUrl;
            let pid;
            let pidsObj;
            let setPids;
            let isPersonalizedProduct = $('.js-personalizeButtonCheckout').length > 0;

            let target = e.currentTarget;
            if ($(target).closest('.js-addToCartStickyBar').length > 0) {
                // open the size modal
                _openStickySizeSelectorModal(target);
                return;
            }
            if ($(target).closest('.js-addToCartStickyBar').length > 0) {
                // close quickview modal
                _openStickySizeSelectorModal(target);
            }

            var $productContainer = $(e.currentTarget).closest('.product-detail');

            if (!$productContainer.length) {
                $productContainer = $(e.currentTarget).closest('.quickview-modal').find('.product-detail');
            }

            if (!$productContainer.length) {
                $productContainer = $('.quickview-modal').find('.product-detail');
            }

            if (!$productContainer.length) {
                $productContainer = $('.product-detail');
            }

            const GTMItem = getGtmData({
                item_id: $('.analytics.product').attr('data-item_id'),
                item_variant: $('.analytics.product').attr('data-item_variant')
            });

            // here we add the personalized product - if there is the personalizeButtonCheckout button, we are adding a pers product
            if (isPersonalizedProduct) {
                var text = $('.form-text').val();

                // here we check the symbolType - in personalization we store the symbols with a number. Here we substitute them with character
                /*
                if ($('.form-symbolType').val() != '') {
                    var symbol = $('.form-symbol').val();

                    switch (symbol) {
                    case '1':
                        symbol = '/_%*_';
                        break;
                    case '2':
                        symbol = '-_%*_';
                        break;
                    case '3':
                        symbol = '__%*_';
                        break;
                    case '4':
                        symbol = '*_%*_';
                        break;
                    }

                    switch ($('.form-symbolType').val()) {
                    case 'letters':
                        switch ($('.form-text').val().length) {
                        case 1:
                            text = $('.form-text').val()[0] + symbol;
                            break;
                        case 2:
                            text = $('.form-text').val()[0] + symbol + $('.form-text').val()[1];
                            break;
                        case 3:
                            text = $('.form-text').val()[0] + $('.form-text').val()[1] + symbol + $('.form-text').val()[2];
                            break;
                        case 4:
                            text = $('.form-text').val()[0] + $('.form-text').val()[1] + symbol + $('.form-text').val()[2] + $('.form-text').val()[3];
                            break;
                        }

                        break;
                    case 'nameSymbol':
                        text = $('.form-text').val() + symbol;
                        break;
                    case 'symbolName':
                        text = symbol + $('.form-text').val();
                        break;
                    default:
                        text = $('.form-text').val();
                    }
                }
                */
                var personalizationText = text;
                var personalizationTextFont;
                personalizationTextFont = $('.form-font').val().indexOf('GillSansNova') > -1
                    ? 'Avant'
                    : ($('.form-font').val().indexOf('Didot') > -1
                        ? 'Didot'
                        : $('.form-font').val().indexOf('Altastgreeting') > -1
                            ? 'Altastgreeting'
                            : '');

                var personalizationColorPref = window.PersonalizationColor.personalizationColor;
                var personalizationColorJson = JSON.parse(personalizationColorPref);

                var personalizationTextColor;
                for (var i = 0; i < personalizationColorJson.length; i++) {
                    if (personalizationColorJson[i].alt === $('.form-color').val()) {
                        var src = personalizationColorJson[i].src;
                        src = src.substring(0, src.lastIndexOf('.'));
                        personalizationTextColor = src;
                    }
                }

                var personalizationPositionKey = $('.form-position').val();

                // ----

                var customizationClassPref = window.CustomizationClass.customizationClass;
                var customizationClassJson = JSON.parse(customizationClassPref);
                var category = $('#category').attr('category-attribute');
                personalizationPositionKey = (customizationClassJson[category]['customizationPositions'] === 1)
                    ? customizationClassJson[category]['0']
                    : customizationClassJson[category][($('.form-position').val()).toString()];

                // ----

                var personalizationTextSVG = $('#base64').attr('data-fullTextSVG');
                var personalizationFullSVG = $('#base64').attr('data-fullSVG');
                var personalizationSmallSVG = $('#base64').attr('data-smallSVG');

                $.spinner().start();

                addToCartUrl = $('#custom-page').attr('data-url');
                var quantity = $('.js-quantity-value').html();
                var uniqueIdentifiers = {};
                for (var i = 0; i < quantity; i++) {
                    var random = Math.random();
                    var id = 'uniqueIdentifier' + i;
                    uniqueIdentifiers[id] = random;
                }
                uniqueIdentifiers = JSON.stringify(uniqueIdentifiers);

                if ($('#pidToAdd').attr('pidRecentlyAdded') == undefined) {
                    // $('#custom-page').attr('data-pid', $('#pidToAdd').attr('data-pid'));
                    $('#pidToAdd').attr('isToLoad', 'false');
                }

                if ($('#pidToAdd').attr('isToLoad') == 'true') {
                    $('#custom-page').attr('data-pid', $('#pidToAdd').attr('pidRecentlyAdded'));
                }

                $('#pidToAdd').attr('pidRecentlyAdded', $('.js-customizePage').data('pid'));

                if (quantity > 1) {
                    var form = {
                        pid: $('.js-customizePage').data('pid'),
                        quantity: quantity,
                        personalizedObj: true,
                        uniqueIdentifiers: uniqueIdentifiers, // Random value
                        personalizationText: personalizationText,
                        personalizationTextFont: personalizationTextFont,
                        personalizationTextColor: personalizationTextColor,
                        personalizationPositionKey: personalizationPositionKey,
                        personalizationTextSVG: personalizationTextSVG,
                        personalizationFullSVG: personalizationFullSVG,
                        personalizationSmallSVG: personalizationSmallSVG,
                        isDate: $('.choice-item.choice-item-3').hasClass('active'),
                        isLove: $('#love').hasClass('active'),
                        GTMItemListName: GTMItem.item_list_name,
                        GTMItemListId: GTMItem.item_list_id,
                        GTMIndex: GTMItem.index
                    };
                } else {
                    var form = {
                        pid: $('.js-customizePage').data('pid'),
                        quantity: quantity,
                        personalizedObj: true,
                        uniqueIdentifier: Math.random(), // Random value
                        personalizationText: personalizationText,
                        personalizationTextFont: personalizationTextFont,
                        personalizationTextColor: personalizationTextColor,
                        personalizationPositionKey: personalizationPositionKey,
                        personalizationTextSVG: personalizationTextSVG,
                        personalizationFullSVG: personalizationFullSVG,
                        personalizationSmallSVG: personalizationSmallSVG,
                        isDate: $('.choice-item.choice-item-3').hasClass('active'),
                        isLove: $('#love').hasClass('active'),
                        GTMItemListName: GTMItem.item_list_name,
                        GTMItemListId: GTMItem.item_list_id,
                        GTMIndex: GTMItem.index
                    };
                }
                $('.js-customizePage .js-customizePage-icon_pageClose').trigger('click');
            } else {
                // ------
                if (!$(e.currentTarget).hasClass('product-set')) {
                    // Simulate disabled button with class to allow click and event
                    if ($(e.currentTarget).data('disabled') || !this.isSizeSelected()) {
                        $('.persButtonPdpAdd').show();
                        $('.persButtonPdpPers').hide();
                        // If no size is selected, open modal to choose one
                        if (!$('.cc-text.selected-size-msg.show-when-size-selected')) {
                            $('#newsletter-error-msg').toggle();
                        }
                        if ($(e.currentTarget).closest('.quickview-modal').length) {
                            // QuickView (Open the other modal type)

                            let modal = $('.js-modal-quick-size-quantity');
                            // First check if it is open
                            if (modal.hasClass('open')) {
                                // Check if size is selected, then add to cart
                            } else {
                                // Show it
                                modal.removeClass('hidden').addClass('open');
                                modal.find('.slick-slider.slick-initialized').slick('refresh');

                                modal.find('.js-close-select-size').on('click', function (e) {
                                    modal.addClass('hidden').removeClass('open');
                                });
                                if ($('.js-modal-quick-size-quantity [data-attr="size"] input#TU:checked').length > 0
                                    && $('.quickview-modal .global-availability').data('ready-to-order')) {
                                    $('.quickview-modal').find('button.add-to-cart-global').data('disabled', false);
                                }
                                if (Foundation.MediaQuery.is('small')) {
                                    $('.quickview-modal .wrapper-details').animate({
                                        scrollTop: $('.wrapper-inner-quick-bottom').eq(0).offset().top
                                    }, 500);
                                }
                            }
                        } else {
                            _openStickySizeSelectorModal(e.currentTarget);
                        }

                        // Prevent further progress until a size is selected
                        return;
                    }
                }

                $('body').trigger('product:beforeAddToCart', e.currentTarget);

                if ($('.set-items').length && $(e.currentTarget).hasClass('add-to-cart-global')) {
                    setPids = [];

                    $('.product-detail').each(function () {
                        if (!$(e.currentTarget).hasClass('product-set-detail')) {
                            setPids.push({
                                pid: $(e.currentTarget).find('.product-id').text(),
                                qty: $(e.currentTarget).find('.quantity-select').val(),
                                options: []
                            });
                        }
                    });
                    pidsObj = JSON.stringify(setPids);
                }

                pid = getPidValue($(e.currentTarget));
                // console.log(pid);

                if ($(target).closest('div.js-pdpStickyBar').length > 0) {
                    $productContainer.addClass('analytics-addToCart-sticky');
                }

                addToCartUrl = getAddToCartUrl();

                let uid = $(e.currentTarget).data('uid');

                var pidSet;
                var buttonAdd = $('button.js-add-to-cart, button.add-to-cart-global, button.update-cart-product-global');

                for (var j = 0; j < buttonAdd.length; j++) {
                    if (uid === $(buttonAdd[i]).data('uid')) {
                        pidSet = $(buttonAdd[i]).attr('data-pid');
                    }
                }

                var promoId = $('.js-promo-msg.marketing-budge', $productContainer).first().data('promotion-id') || false;

                // ------
                var form = {
                    pid: pid || pidSet,
                    pidsObj: pidsObj,
                    childProducts: [],
                    quantity: getQuantitySelected($(e.currentTarget)),
                    uuid: uid,
                    promoId: promoId,
                    GTMItemListName: GTMItem.item_list_name,
                    GTMItemListId: GTMItem.item_list_id,
                    GTMIndex: GTMItem.index
                };

                if (!$('.bundle-item').length) {
                    form.options = [];
                }

                if ($('.js-complete-your-promo').length > 0) {
                    $('.js-complete-the-promo-status').val($('.js-complete-the-promo-status').val() - form.quantity);
                    form.completePromoItems = $('.js-complete-the-promo-status').val();
                    $productContainer.addClass('analytics-completeYourPromo');
                }
            }

            $(e.currentTarget).trigger('updateAddToCartFormData', form);
            $('body').trigger('updateQuickAddToCartModal', form);
            const _self = this;
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: data => {
                        sizePanel.close();
                        //synced with changeAddToBagButton from details.js
                        setTimeout(() => {
                            sizePanel.switchButtons();
                            sizePanel.switchButtonsSticky();
                        }, 3000);
                        _self.setUpdateCartListener(data, form.pid, $productContainer);

                        $.spinner().stop();
                        if (data.error && isPersonalizedProduct) {
                            $('.content-input-err').removeClass('hidden');
                        } else {
                            if (data.completePromoItemsLabel && data.completePromoItemsLabel !== '' && $('.js-completeYourPromo-header_remaining').length > 0) {
                                $('.js-completeYourPromo-header_remaining').html(data.completePromoItemsLabel);
                                if (form.completePromoItems <= '0') {
                                    $('.js-completeYourPromo-header_remaining').addClass('cc-cartPromotionModal-footer_completed');
                                    $('.js-complete-your-promo-modal .js-back-button').trigger('click');
                                }
                            }
                            $('body').trigger('product:afterAddToCart', {
                                ...data,
                                form,
                                $productContainer
                            });
                            data.quantityTotal = data.cart ? data.cart.numItems : data.cartModel.numItems;
                            handlePostCartAdd(data);
                        }
                    },
                    error: () => {
                        $.spinner().stop();
                    }
                });
            }
        });
    }

    setUpdateCartListener (res, pid, $productContainer) {
        const { updateQuantityUrl, removeProductLineItemUrl } = res.cart.actionUrls;
        const addToCartUrl = getAddToCartUrl();
        const $wrapper = $('.js-pdpStickyBar');
        $wrapper.find('.js-quantity-button').attr('data-url', updateQuantityUrl);
        $wrapper.find('.cc-quantity-sticky').removeClass('cc-quantity-sticky').addClass('cc-quantity-sticky-show');
        $wrapper.find('.js-quantity-button').removeClass('js-quantity-button').addClass('js-quantity-button-sticky');
        $wrapper.find('.js-quantity-value').removeClass('js-quantity-value').addClass('js-quantity-value-sticky');
        $wrapper.find('.cc-quantity-button.disabled').removeClass('disabled');
        $wrapper.find('.cc-quantity-sticky-show .js-quantity-value-sticky').text(res.cart.items.filter(c => c.id === pid).length);
        $wrapper.find('.js-quantity-button-sticky').off('click');
        var uuidOfFirstItem = res.cart.items.find(c => c.id === pid)?.UUID ?? null;
        $wrapper.find('.js-quantity-button-sticky').on('click', (e) => {
            e.preventDefault();
            const action = $(e.currentTarget).data('action');
            const url = action === 'increase' ? addToCartUrl : removeProductLineItemUrl;
            const promoId = $('.js-promo-msg.marketing-budge').first().data('promotion-id') || false;
            const form = { pid };
            if (action === 'increase') {
                form.quantity = 1;
                form.promoId = promoId;
            } else {
                let itemsNo = res.cart.items.filter(c => c.id === pid).length;
                if (itemsNo === 0 || !uuidOfFirstItem) return;
                form.uuid = uuidOfFirstItem;
            }
            const method = action === 'increase' ? 'POST' : 'GET';
            $.spinner().start();
            $.ajax({
                url,
                data: form,
                method,
                dataType: 'json',
                success: (res) => {
                    if (action === 'increase') {
                        $('.js-quantity-value-sticky').text(res.cart.items.filter(c => c.id === pid).length);
                        if (res.error && $('.js-personalizeButtonCheckout').length > 0) {
                            $('.content-input-err').removeClass('hidden');
                        } else {
                            if (res.completePromoItemsLabel && res.completePromoItemsLabel !== '' && $('.js-completeYourPromo-header_remaining').length > 0) {
                                $('.js-completeYourPromo-header_remaining').html(res.completePromoItemsLabel);
                                if (form.completePromoItems <= '0') {
                                    $('.js-completeYourPromo-header_remaining').addClass('cc-cartPromotionModal-footer_completed');
                                    $('.js-complete-your-promo-modal .js-back-button').trigger('click');
                                }
                            }
                            $('body').trigger('product:afterAddToCart', {
                                ...res,
                                form,
                                $productContainer
                            });
                            res.quantityTotal = res.cart ? res.cart.numItems : res.cartModel.numItems;
                            handlePostCartAdd(res);
                            uuidOfFirstItem = res.cart.items.filter(c => c.id === pid).length > 0 ? res.cart.items.filter(c => c.id === pid)[0].UUID : null;
                        }
                    } else {
                        $('.js-quantity-value-sticky').text(res.cartModel.items.filter(c => c.id === pid).length);
                        $('.js-mainHeader-minicart').trigger('count:update', res);
                        uuidOfFirstItem = res.cartModel.items.filter(c => c.id === pid).length > 0 ? res.cartModel.items.filter(c => c.id === pid)[0].UUID : null;
                    }
                    $.spinner().stop();
                },
                error: (err) => {
                    console.log('Error:', err);
                    $.spinner().stop();
                },
            });
        });
    }

    /*
    selectBonusProduct () {
        $('body').on('click', '.select-bonus-product', function () {
            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            var pid = $(this).data('pid');
            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            var submittedQty = parseInt($(this).parents('.choice-of-bonus-product').find('.bonus-quantity-select').val(), 10);
            var totalQty = 0;
            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });
            totalQty += submittedQty;
            var optionID = $(this).parents('.choice-of-bonus-product').find('.product-option').data('option-id');
            var valueId = $(this).parents('.choice-of-bonus-product').find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                const selectedBonusProductHtml = `
                    <div class="selected-pid grid-x"
                        data-pid="${pid}"
                        data-qty="${submittedQty}"
                        data-optionID="${(optionID || '')}"
                        data-option-selected-value="${(valueId || '')}">

                        <div class="cell medium-10 h5">${$choiceOfBonusProduct.find('.product-name').html()}</div>'
                        <div class="cell medium-1">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </div>
                    </div>`;

                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
                $('.pre-cart-products').html(totalQty);
                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }
        });
    }
    */

    sizeTU() {
        if (document.getElementById('TU')) {
            document.getElementById('TU').click();
        }
    }

    quickAddListener() {
        $('body').on('click', '.js-panel-opener-size-quick-add', function (e, data) {
            /** open/close quickAdd modal**/
            e.preventDefault();
            if ($(this).find('.icon-toggle-top.triangle-dropdown-pdp').hasClass('icon-toggle-opened')) {
                $('.js-modal-quick-add-size-quantity').addClass('hidden');
                $('.product-detail-quick-add .icon-toggle-top.triangle-dropdown-pdp').removeClass('icon-toggle-opened');
                $('.product-detail-quick-add .size-opener-opened').addClass('hidden');
                $('.product-detail-quick-add .size-opener-closed').removeClass('hidden');
            } else {
                $('.product-detail-quick-add .icon-toggle-top.triangle-dropdown-pdp').removeClass('icon-toggle-opened');
                $(this).find('.icon-toggle-top.triangle-dropdown-pdp').addClass('icon-toggle-opened');
                var mustAdd = (data && data.mustAdd === true) || false;
                $(this).closest('.product-detail-quick-add').find('.add-to-cart-quick-add').data('mustAdd', mustAdd);
                const pid = $(this).attr('data-pid');
                const url = $(this).attr('data-get-url');
                $(this).find('.size-opener-opened').removeClass('hidden');
                $(this).find('.size-opener-closed').addClass('hidden');
                showQuickAddItems(pid, url);
            }
        });

        $('body').on('click', '.js-close-select-size-quick-add', function (e) {
            /** close quickAdd modal**/
            e.preventDefault();
            $('.js-modal-quick-add-size-quantity').addClass('hidden');
            $('.product-detail-quick-add .icon-toggle-top.triangle-dropdown-pdp').removeClass('icon-toggle-opened');
            $('.product-detail-quick-add .size-opener-opened').addClass('hidden');
            $('.product-detail-quick-add .size-opener-closed').removeClass('hidden');
        });

        $('body').on('change', '[data-attr="size_qa"] input ', e => {
            /** change size and update attribute for the cart**/
            e.preventDefault();
            const selectedValue = $(e.currentTarget).attr('value');
            if (selectedValue === 'null') {
                return;
            }

            let $productContainer = $(e.currentTarget).closest('.product-detail-quick-add');
            if ($productContainer && $productContainer.length > 0) {
                attributeSelectQuickAdd(selectedValue, $productContainer, '_', false);
                $productContainer.find('.add-to-cart-quick-add').attr('data-size-available', true);
                $productContainer.find('.add-to-cart-quick-add').attr('data-size-selected', $(e.currentTarget).data('attr-id'));
                $productContainer.find('.add-to-cart-quick-add').removeClass('item-added-quick');
            }
            $('body').trigger('product:didChangeSize');
        });

        $('body').on('product:updateAddToCartQuickAdd', (e, response) => {
            /** manage response variation after size selection **/
            let availabilityValue = '';
            let availabilityMessages = response.product.availability.messages;
            var $productContainer = response.$productContainer;
            $productContainer.find('.response-message-quick-add').empty();
            if ($productContainer.find('[data-attr="size_qa"] input:checked') && $productContainer.find('[data-attr="size_qa"] input:checked').length > 0) {
                var sizeChecked = $productContainer.find('[data-attr="size_qa"] input:checked').attr('data-display-value');
                $productContainer.find('.size-selected').text(sizeChecked);
                $productContainer.find('.response-message-quick-add').addClass('hidden');
                $productContainer.find('.add-to-cart-quick-add').attr('data-size-available', true);
                $productContainer.find('.add-to-cart-quick-add').attr('data-pid', response.product.id);
                $productContainer.find('.response-error-quick-add').addClass('hidden');
            }
            if (!response.product.readyToOrder) {
                $productContainer.find('.add-to-cart-quick-add').attr('data-disabled', true);
                $productContainer.find('.add-to-cart-quick-add').attr('disabled', true);
            } else if (!response.product.available || response.product.comingSoon) {
                $productContainer.find('.add-to-cart-quick-add').attr('data-disabled', true);
                $productContainer.find('.add-to-cart-quick-add').attr('disabled', true);
                availabilityMessages.forEach(message => {
                    availabilityValue += `<div>${message}</div>`;
                });
                $productContainer.find('.response-message-quick-add').html(availabilityValue);
            } else {
                $productContainer.find('.add-to-cart-quick-add').attr('data-disabled', false);
                $productContainer.find('.add-to-cart-quick-add').attr('disabled', false);
            }
        });

        $('body').on('click', 'button.add-to-cart-quick-add', (e) => {
            if ($(e.currentTarget).closest('.completeYourLookContainer').length > 0) {
                localStorage.setItem('prevlisttypeforcart', localStorage.getItem('listtypeforcart'));
                localStorage.setItem('listtypeforcart', 'complete_your_look');
            }

            let addToCartUrl;
            let pidsObj;
            const $productContainer = $(e.currentTarget).closest('.product-detail-quick-add');
            // Simulate disabled button with class to allow click and event
            if ($(e.currentTarget).attr('data-size-available') !== 'true') {
                $productContainer.find('.response-message-quick-add').removeClass('hidden');
                return;
            } else if ($(e.currentTarget).attr('data-disabled') === 'true' || $(e.currentTarget).attr('data-disabled') === 'NaN') {
                return;
            }
            $productContainer.find('.response-message-quick-add').addClass('hidden');
            $productContainer.find('.response-error-quick-add').addClass('hidden');

            $('body').trigger('product:beforeAddToCart', e.currentTarget);

            let pid = $(e.currentTarget).attr('data-pid');
            let uid = $(e.currentTarget).attr('data-uid');
            let quantitySelected = parseInt($(e.currentTarget).attr('data-quantity')) || 1;

            addToCartUrl = getAddToCartUrl();

            let promoId = false;
            if ($('.promoCrossSellEnabled').length > 0) {
                promoId = $('.js-promo-msg.marketing-budge').first().data('promotion-id') || false;
            }

            const GTMItem = getGtmData({
                item_id: $('.analytics.product').attr('data-item_id'),
                item_variant: $('.analytics.product').attr('data-item_variant')
            });

            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: [],
                quantity: quantitySelected,
                uuid: uid,
                promoId: promoId,
                GTMItemListName: GTMItem.item_list_name,
                GTMItemListId: GTMItem.item_list_id,
                GTMIndex: GTMItem.index
            };

            $(e.currentTarget).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: data => {
                        $.spinner().stop();
                        if (data.error) {
                            $productContainer.find('.response-error-quick-add').removeClass('hidden');
                        } else {
                            $('body').trigger('product:afterAddToCart', {
                                ...data,
                                form,
                                $productContainer
                            });
                            data.quantityTotal = data.cart.numItems;
                            handlePostCartAdd(data);
                            $productContainer.find('.add-to-cart-quick-add').addClass('item-added-quick');
                            $('.js-modal-quick-add-size-quantity').addClass('hidden');
                            $('.product-detail-quick-add .icon-toggle-top.triangle-dropdown-pdp').removeClass('icon-toggle-opened');
                            $('.product-detail-quick-add .size-opener-opened').addClass('hidden');
                            $('.product-detail-quick-add .size-opener-closed').removeClass('hidden');
                        }
                    },
                    error: () => {
                        $.spinner().stop();
                    }
                });
            }
        });
    }

    checkSoldoutAvailability() {
        if ($('.page').data('action') !== 'Product-Show') {
            return;
        }
        var $productContainer = $('div.product-detail.container').first();
        var attributesUpdateUrl = $productContainer.data('variationAttrUpdate');
        if (!attributesUpdateUrl) {
            return;
        }
        $.ajax({
            url: attributesUpdateUrl,
            method: 'GET',
            dataType: 'json',
            success: data => {
                if (data.product && data.product.variationAttributes) {
                    updateAttrs(data.product.variationAttributes, $productContainer);
                    updateAvailability(data, $productContainer);
                    $('body').trigger('product:updateAddToCart', {
                        product: data.product,
                        $productContainer: $productContainer
                    });
                    // reorder swatches in order to push soldout colors in the laste positions
                    reorderSwatches($('.js-carousel-select-color.not-sale-container'));
                    reorderSwatches($('.js-carousel-select-color.on-sale-container'));
                }
            }
        });
    }
    registerAttributionTokenSending() {
        $('body').on('click', '.js-google-recommendations-container .js-prodTile', function () {
            const attributionToken = $(this).closest('.js-google-recommendations-container').data('attributionToken');
            createCookie('attribution_token', attributionToken);
        });
    }
    loadGoogleRecommendations() {
        const $googleConfig = $('.js-googleRecommendationConfig');
        if ($googleConfig.length) {
            const url = $('#googleRecommendationsUrl').val();
            const servingConfig = $googleConfig.data('servingConfig');
            const nodeToAppendTo = $googleConfig.data('nodeToAppendTo');
            const cgid = $('#primaryCategoryId').val();
            const sku = $('#variationGroupSku').val();
            const route = $('.page').data('action');

            $.ajax({
                type: 'GET',
                url: url,
                data: {
                    cgid: cgid,
                    sku: sku,
                    route: route,
                    servingConfig: servingConfig
                },
                success: function (html) {
                    const $outputContainer = $(nodeToAppendTo).find('.google-recommendation-results');
                    if (!$outputContainer.length) {
                        $('<div class="google-recommendation-results"></div>').appendTo(nodeToAppendTo);
                    }
                    $(nodeToAppendTo).find('.google-recommendation-results').empty().append(html);
                },
                error: function () {
                    $('#youMayAlsoLikeContainer').addClass('hidden');
                }
            });
        }
    }
}

const productHelpers = new ProductHelpers();
export default productHelpers;
export {
    moveModalCloseButton,
    parseHtml,
    activatePromoAnimationMessage,
    updateColorFamily,
    updatePrices,
    updateAvailability,
    updateOptions,
    updateQuantities,
    isMiniCartOpen,
    isChooseBonusProductModalOpen,
    isQuickUpdateFromModal,
    isMobileDevice
};
